/* William Painter — Build Your Own Pair (prescription + nonprescription lens builder)
 * Self-contained web component (shadowRoot). Stepped configurator for prescription lenses.
 * Adds the selected priced components to the cart as a locked bundle (shared _rx_bundle token),
 * with the full spec as line-item properties on the anchor line. See PRESCRIPTION-LENSES-ROADMAP.md.
 * Loaded only on the Prescription Builder page (and reused via the PDP deep-link).
 */
(function () {
  'use strict';
  if (customElements.get('wp-rx-builder')) return;

  var money = function (n) { n = Number(n || 0); return '$' + n.toFixed(n % 1 ? 2 : 0); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]; }); };
  var uid = function () { return 'rx_' + Math.random().toString(36).slice(2) + Date.now().toString(36); };

  var CSS = "\
:host{all:initial;font-family:inherit;color:#1d1d1f;display:block}\
*{box-sizing:border-box}\
.wrap{max-width:1180px;margin:0 auto;padding:24px 16px 120px;display:grid;grid-template-columns:1fr 340px;gap:32px}\
@media(max-width:880px){.wrap{grid-template-columns:1fr}}\
h1{font-size:26px;font-weight:700;letter-spacing:-.02em;margin:0 0 4px}\
h2{font-size:21px;font-weight:600;margin:0 0 16px}\
p{line-height:1.5}\
.muted{color:#6e6e73;font-size:14px}\
.stepper{display:flex;gap:6px;flex-wrap:wrap;margin:14px 0 26px}\
.stepper b{flex:1;min-width:36px;height:4px;border-radius:2px;background:#e6e6e6;transition:background .25s}\
.stepper b.done{background:#c8a96a}.stepper b.active{background:#1d1d1f}\
.opts{display:grid;gap:12px}\
.opt{display:flex;align-items:center;justify-content:space-between;gap:14px;border:1.5px solid #e6e6e6;border-radius:14px;padding:16px 18px;cursor:pointer;transition:border-color .15s,box-shadow .15s,background .15s;background:#fff;text-align:left;width:100%;font:inherit;color:inherit}\
.opt:hover{border-color:#c9c9cd}\
.opt.sel{border-color:#1d1d1f;box-shadow:0 0 0 1px #1d1d1f}\
.opt .t{font-weight:600;font-size:15px;display:block}\
.opt .d{font-size:13px;color:#6e6e73;margin-top:4px;display:block;line-height:1.4}\
.opt .price{font-weight:600;font-size:15px;white-space:nowrap}\
.opt .price.free{color:#1a8f3c}\
.grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:14px}\
.frame{border:1.5px solid #e6e6e6;border-radius:14px;padding:10px;cursor:pointer;background:#fff;transition:border-color .15s,box-shadow .15s}\
.frame.sel{border-color:#1d1d1f;box-shadow:0 0 0 1px #1d1d1f}\
.frame img{width:100%;aspect-ratio:4/3;object-fit:cover;background:#f5f5f7;border-radius:8px}\
.frame.oos{opacity:.45}\
.frame__ph{display:block;width:100%;aspect-ratio:4/3;background:#f5f5f7;border-radius:8px}\
.frame__ph--other{display:flex;align-items:center;justify-content:center;font-size:30px;font-weight:600;color:#9a9aa0}\
.ownh{font-size:16px;font-weight:600;margin:18px 0 12px}\
.frame .t{font-weight:600;font-size:13px;margin-top:8px}\
.frame .ft{font-size:12px;color:#6e6e73}\
.frame .ft s{color:#b0b0b5}.frame .ft b{color:#1d1d1f}\
.vpick{margin-top:4px}\
.vprice{margin-top:16px;font-size:15px;color:#6e6e73}\
.vprice s{color:#b0b0b5;margin-right:6px}.vprice strong{font-size:18px;color:#1d1d1f}\
.chip.oos{opacity:.4;text-decoration:line-through;cursor:not-allowed}\
.chips{display:flex;flex-wrap:wrap;gap:8px;margin-top:10px}\
.chip{border:1.5px solid #e6e6e6;border-radius:999px;padding:9px 16px;min-height:40px;display:inline-flex;align-items:center;cursor:pointer;font-size:13px;background:#fff;font:inherit}\
.chip.sel{border-color:#1d1d1f;background:#1d1d1f;color:#fff}\
.sw{width:26px;height:26px;border-radius:50%;border:1px solid rgba(0,0,0,.15);display:inline-block;vertical-align:middle;margin-right:7px}\
.field{display:block;margin:12px 0}\
.field label{display:block;font-size:13px;font-weight:600;margin-bottom:6px}\
.field input,.field select,.field textarea{width:100%;border:1.5px solid #e6e6e6;border-radius:10px;padding:11px 12px;font:inherit;font-size:16px;background:#fff}\
.rx-grid{display:grid;grid-template-columns:repeat(5,1fr);gap:8px;align-items:end}\
.note{background:#f5f5f7;border-radius:12px;padding:14px 16px;font-size:13px;color:#444;margin:14px 0}\
.rx-incl{background:#f4f8f4;border:1px solid #cfe3cf;border-radius:12px;padding:14px 16px;font-size:13px;color:#2f6b31;margin:14px 0;line-height:1.5}\
.rx-incl strong{color:#1a8f3c}\
.linkback{background:none;border:none;color:#6e6e73;font:inherit;font-size:13px;cursor:pointer;padding:4px 0;margin-bottom:6px}\
.linkback:hover{color:#1d1d1f}\
.lensprev{display:flex;justify-content:center;margin:6px 0 20px}\
.lensprev svg{width:100%;max-width:300px;height:auto}\
.lensphoto{position:relative;width:100%;max-width:320px;aspect-ratio:1/1;border-radius:16px;overflow:hidden;background:#fff}\
.lensphoto img{display:block;width:100%;height:100%;object-fit:contain}\
.lensphoto__tint{position:absolute;inset:0;opacity:.7;pointer-events:none}\
.lensrender-wrap{position:relative}\
.lensrender-wrap.is-grad::after{content:'';position:absolute;inset:0;border-radius:inherit;pointer-events:none;background:linear-gradient(to bottom,rgba(255,255,255,0) 34%,rgba(255,255,255,.55) 72%,rgba(255,255,255,.85) 100%)}\
.lensrender-wrap{width:100%;max-width:360px;aspect-ratio:1680/1360;display:flex;align-items:center;justify-content:center}\
.lensrender{width:100%;height:100%;object-fit:contain;display:block}\
.tint__render{width:54px;height:44px;object-fit:contain;display:block}\
.tints{display:grid;grid-template-columns:repeat(auto-fill,minmax(84px,1fr));gap:12px}\
.tint{border:1.5px solid #e6e6e6;border-radius:14px;padding:12px 8px;cursor:pointer;background:#fff;font:inherit;display:flex;flex-direction:column;align-items:center;gap:8px;transition:border-color .15s,box-shadow .18s,transform .1s}\
.tint:hover{border-color:#c9c9cd}\
.tint.sel{border-color:#1d1d1f;box-shadow:0 0 0 1px #1d1d1f}\
.tint:active{transform:scale(.98)}\
.tint__sw{width:44px;height:44px;border-radius:50%;border:1px solid rgba(0,0,0,.14);background-position:center;background-size:cover}\
.tint__n{font-size:12px;font-weight:600;color:#1d1d1f}\
.disc{font-size:14px;line-height:1.5;color:#1d1d1f;margin:14px 0 6px}\
.ship{font-size:13px;margin-bottom:4px}\
.rx-soon{background:#f5f5f7;border:1px solid #e3e3e3;border-radius:16px;padding:28px 24px;margin:18px 0;text-align:center}\
.rx-soon .rx-soon-badge{display:inline-block;background:#1d1d1f;color:#fff;font-size:11px;font-weight:600;letter-spacing:.08em;text-transform:uppercase;padding:5px 12px;border-radius:999px;margin-bottom:12px}\
.rx-soon h3{font-size:18px;font-weight:600;margin:0 0 8px;color:#1d1d1f}\
.rx-soon p{font-size:14px;line-height:1.5;color:#6e6e73;margin:0 auto;max-width:34em}\
.toggle{display:flex;gap:10px;margin:14px 0}\
.toggle .opt{flex:1;justify-content:center}\
.nav{position:sticky;bottom:0;z-index:20;display:flex;align-items:center;gap:12px;margin-top:28px;padding:14px 0 calc(14px + env(safe-area-inset-bottom));background:#fff;border-top:1px solid #efefef}\
.nav__total{display:none;flex-direction:column;align-items:flex-start;gap:1px;border:none;background:none;padding:2px 4px;font:inherit;color:inherit;cursor:pointer;text-align:left;border-radius:8px;white-space:nowrap}\
.nav__tl{color:#6e6e73;font-size:12px;display:flex;align-items:center;gap:3px}\
.nav__tv{font-weight:700;font-size:17px}\
.nav__from{color:#6e6e73;font-size:12px;display:flex;align-items:center;gap:3px;line-height:1.35}.nav__from strong{color:#1d1d1f;font-size:14px}\
.nav__btns{display:flex;gap:10px;flex:1;justify-content:space-between}\
.btn{border:none;border-radius:999px;padding:14px 26px;font:inherit;font-weight:700;font-size:15px;cursor:pointer;transition:opacity .15s,transform .05s}\
.btn:active{transform:translateY(1px)}\
.btn--p{background:#1d1d1f;color:#fff}\
.btn--g{background:#c8a96a;color:#1d1d1f}\
.btn--o{background:transparent;color:#1d1d1f;border:1.5px solid #d2d2d7}\
.btn[disabled]{opacity:.4;cursor:not-allowed}\
.summary{position:sticky;top:20px;align-self:start;border:1px solid #e6e6e6;border-radius:16px;padding:20px;background:#fff}\
.summary h3{margin:0 0 14px;font-size:16px}\
.sumframe{display:flex;gap:12px;align-items:center;margin-bottom:14px}\
.sumframe img{width:56px;height:56px;object-fit:contain;background:#f5f5f7;border-radius:8px}\
.lines{border-top:1px solid #eee;padding-top:12px}\
.line{display:flex;justify-content:space-between;font-size:14px;padding:5px 0;gap:10px}\
.line .v{color:#6e6e73;text-align:right}\
.total{display:flex;justify-content:space-between;font-weight:700;font-size:18px;border-top:1px solid #eee;margin-top:10px;padding-top:12px}\
@media(max-width:880px){.summary{display:none}}\
.collapse summary{cursor:pointer;font-size:13px;color:#6e6e73;margin-top:10px}\
.err{color:#c0392b;font-size:13px;margin-top:8px}\
.rx-hint{background:#fef3f2;border:1px solid #f3c9c3;border-radius:10px;padding:10px 12px;margin-top:14px;font-size:13px;color:#9b2c1f}\
.rx-hint div{margin:2px 0;line-height:1.4}\
/* --- polish: motion --- */\
.step--fwd{animation:rxIn .34s cubic-bezier(.22,.61,.36,1) both}\
.step--back{animation:rxInBack .34s cubic-bezier(.22,.61,.36,1) both}\
@keyframes rxIn{from{opacity:0;transform:translate3d(22px,0,0)}to{opacity:1;transform:none}}\
@keyframes rxInBack{from{opacity:0;transform:translate3d(-22px,0,0)}to{opacity:1;transform:none}}\
@keyframes rxPop{0%{transform:scale(.96)}55%{transform:scale(1.03)}100%{transform:scale(1)}}\
@keyframes rxPulse{0%{transform:scale(1)}40%{transform:scale(1.07);color:#a07c1f}100%{transform:scale(1)}}\
h1,.muted{opacity:1}\
.stepper b{transition:background .3s ease,transform .3s ease}\
.stepper b.active{transform:scaleY(1.75)}\
.opt{transition:border-color .15s,box-shadow .18s,background .15s,transform .1s}\
.opt:active{transform:scale(.99)}\
.opt.sel{box-shadow:0 0 0 1px #1d1d1f,inset 3px 0 0 0 #c8a96a;animation:rxPop .26s ease}\
.frame{position:relative;transition:border-color .15s,box-shadow .18s,transform .1s}\
.frame:active{transform:scale(.98)}\
.frame.sel{animation:rxPop .26s ease}\
.frame.sel::after{content:'\\2713';position:absolute;top:8px;right:8px;width:22px;height:22px;border-radius:50%;background:#1d1d1f;color:#fff;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;animation:rxPop .3s ease}\
.frame img{transition:transform .25s ease}.frame:hover img{transform:scale(1.03)}\
.img--angle{filter:brightness(1.026)}.frame img.img--angle{transform:scale(.94)}.frame:hover img.img--angle{transform:scale(.97)}\
.chip{transition:border-color .15s,background .15s,color .15s,transform .1s}.chip:active{transform:scale(.96)}\
.btn{transition:opacity .15s,transform .08s,box-shadow .15s}\
.btn--p:hover,.btn--g:hover{opacity:.92}.btn--o:hover{border-color:#1d1d1f}\
.field input,.field select,.field textarea{transition:border-color .15s,box-shadow .15s}\
.field input:focus,.field select:focus,.field textarea:focus{outline:none;border-color:#1d1d1f;box-shadow:0 0 0 3px rgba(29,29,31,.08)}\
.total .v,.total span:last-child{display:inline-block;transition:color .3s}\
.total--pulse span:last-child{animation:rxPulse .45s ease}\
.opt:focus-visible,.frame__pick:focus-visible,.fdot:focus-visible,.tint:focus-visible,.chip:focus-visible,.btn:focus-visible,.nav__total:focus-visible,.linkbtn:focus-visible,.pdetails summary:focus-visible{outline:2px solid #1d1d1f;outline-offset:2px}\
.agbox input:focus-visible{outline:2px solid #1d1d1f;outline-offset:3px}\
/* --- polish: mobile --- */\
.msheet{display:none}\
@media(max-width:880px){\
  .wrap{padding:18px 16px calc(104px + env(safe-area-inset-bottom))}\
  h1{font-size:22px}h2{font-size:18px}\
  .grid{grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:10px}\
  .rx-grid{grid-template-columns:repeat(2,1fr)}\
  .toggle{flex-direction:column}\
  .nav{position:fixed;left:0;right:0;bottom:0;z-index:60;margin:0;border-top:1px solid #ececec;padding:10px 12px calc(10px + env(safe-area-inset-bottom));box-shadow:0 -6px 24px rgba(0,0,0,.07)}\
  .nav__total{display:flex}\
  .nav__btns{flex:1;justify-content:flex-end}\
  .nav .btn{padding:13px 16px}\
  .nav [data-next],.nav [data-add]{flex:1;max-width:220px}\
  .msheet{display:block;position:fixed;inset:0;z-index:70;visibility:hidden}\
  .msheet.open{visibility:visible}\
  .msheet__bd{position:absolute;inset:0;background:rgba(0,0,0,.42);opacity:0;transition:opacity .32s}\
  .msheet.open .msheet__bd{opacity:1}\
  .msheet__panel{position:absolute;left:0;right:0;bottom:0;background:#fff;border-radius:20px 20px 0 0;padding:14px 20px calc(20px + env(safe-area-inset-bottom));transform:translateY(101%);transition:transform .36s cubic-bezier(.22,.61,.36,1);max-height:82vh;overflow:auto;overscroll-behavior:contain;box-shadow:0 -10px 40px rgba(0,0,0,.18)}\
  .msheet.open .msheet__panel{transform:none}\
  .msheet__grip{width:42px;height:4px;border-radius:2px;background:#dcdcdc;margin:2px auto 16px}\
  .msheet__panel h3{margin:0 0 14px;font-size:16px}\
}\
/* --- phones: next-step bar pinned under the site header --- */\
.topbar{display:none}\
.sr{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0}\
@media(max-width:880px){\
  .topbar{display:flex;align-items:center;gap:12px;position:fixed;left:0;right:0;top:var(--rx-top,0px);z-index:50;background:#fff;border-bottom:1px solid #ececec;box-shadow:0 8px 20px rgba(0,0,0,.08);padding:8px 12px 8px 16px;transform:translateY(-110%);visibility:hidden;transition:transform .28s cubic-bezier(.22,.61,.36,1),visibility 0s linear .28s}\
  .topbar.on{transform:none;visibility:visible;transition:transform .28s cubic-bezier(.22,.61,.36,1),visibility 0s}\
  .topbar__txt{flex:1;min-width:0;display:flex;flex-direction:column}\
  .topbar__k{font-size:11px;color:#6e6e73;text-transform:uppercase;letter-spacing:.06em}\
  .topbar__v{font-size:14px;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}\
  .topbar .btn{padding:11px 18px;font-size:14px;white-space:nowrap;flex:0 0 auto}\
}\
@media(prefers-reduced-motion:reduce){\
  .topbar,.topbar.on{transition:none!important;transform:none}\
  .step--fwd,.step--back,.opt.sel,.frame.sel,.frame.sel::after,.total--pulse span:last-child{animation:none!important}\
  *{transition-duration:.001s!important}\
}\
/* --- Build Your Own Pair --- */\
.opt__sw{flex:0 0 52px;width:52px;height:42px;object-fit:contain}\
.opt__body{flex:1;min-width:0}\
.opt[disabled]{opacity:.45;cursor:not-allowed}\
.lensswatch{width:100%;max-width:260px;display:flex;justify-content:center}\
.lensswatch img{width:100%;height:auto;display:block;transition:opacity .2s}\
.lensswatch.int-light img{opacity:.5}.lensswatch.int-medium img{opacity:.78}\
/* --- design review (2026-09) --- */\
.main{min-width:0}\
.sw--clear{background:#eceef1;border-radius:10px;box-shadow:inset 0 0 0 1px rgba(0,0,0,.06)}\
.opt__sw.sw--clear{padding:4px 5px}.pair__sw.sw--clear{padding:8px 10px}\
@media(max-width:600px){\
  .opt .cdots{gap:3px}.opt .cdot{width:12px;height:12px}\
}\
.cards{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin:14px 0}\
.card{display:flex;flex-direction:column;align-items:flex-start;gap:6px;border:1.5px solid #e6e6e6;border-radius:14px;padding:18px;background:#fff;font:inherit;color:inherit;text-align:left;cursor:pointer;width:100%;transition:border-color .15s,box-shadow .18s,transform .1s}\
.card:hover{border-color:#c9c9cd}\
.card.sel{border-color:#1d1d1f;box-shadow:0 0 0 1px #1d1d1f,inset 0 3px 0 0 #c8a96a}\
.card:active{transform:scale(.99)}\
.card[disabled]{opacity:.45;cursor:not-allowed}\
.card:focus-visible{outline:2px solid #1d1d1f;outline-offset:2px}\
.card__ic{width:40px;height:40px;color:#1d1d1f;margin-bottom:2px}\
.card__ic svg{width:100%;height:100%;display:block}\
.card .t{font-weight:600;font-size:16px}\
.card .d{font-size:13px;color:#6e6e73;line-height:1.45}\
.card .price{font-weight:600;font-size:15px;margin-top:auto;padding-top:4px}\
.card--lg{padding:22px 20px;min-height:190px}\
.card--lg .card__ic{width:48px;height:48px}\
.both{font-size:14px;font-weight:600;margin:4px 0 0}\
.eta{font-size:13px;color:#6e6e73;margin:-4px 0 10px}\
.nav__add{display:flex;align-items:center;gap:14px;min-width:0}\
.nav__eta{font-size:13px;color:#6e6e73;line-height:1.35;text-align:right;max-width:320px}\
.nav__btns{align-items:center}\
.cards--compact .card{flex-direction:row;align-items:center;gap:10px;padding:12px 14px}\
.cards--compact .card__ic{width:28px;height:28px;margin:0}\
.cards--compact .d{display:none}\
.frame{padding:0}\
.frame__pick{display:block;width:100%;border:none;background:none;padding:10px 10px 4px;font:inherit;color:inherit;text-align:left;cursor:pointer;border-radius:14px}\
.frame__meta{display:flex;flex-wrap:wrap;align-items:center;gap:6px 8px;padding:0 10px 12px;min-height:30px}\
.fdots{display:flex;gap:6px}\
.fdot{width:22px;height:22px;border-radius:50%;border:1.5px solid #fff;box-shadow:0 0 0 1px #c9c9cd;padding:0;cursor:pointer;background:#ccc}\
.fdot.sel{box-shadow:0 0 0 2px #1d1d1f}\
.fcolor{font-size:12px;color:#6e6e73}\
.ftag{display:inline-block;margin-top:5px;font-size:10.5px;font-weight:600;letter-spacing:.04em;text-transform:uppercase;color:#6b5a2e;background:#f6efdf;border-radius:999px;padding:3px 8px}\
.opt .cnt{font-weight:400;color:#6e6e73}\
.cdots{display:flex;flex-wrap:wrap;gap:4px;margin-top:7px}\
.cdot{width:14px;height:14px;border-radius:50%;border:1px solid rgba(0,0,0,.14);background-size:260%;background-position:center}\
.tintview{display:flex;flex-direction:column}.tintview .linkback{align-self:flex-start}\
.tv-dark .field{margin:0 0 6px}\
.fnote{display:block;margin-top:5px;font-size:12px;line-height:1.35;color:#6e6e73;font-weight:400}\
.rx-range{margin:0 0 10px}\
.tv-darknote{margin:2px 0 6px;font-size:13px;line-height:1.4}\
.linkbtn{background:none;border:none;padding:6px 0;font:inherit;font-size:13px;color:#1d1d1f;text-decoration:underline;text-underline-offset:3px;cursor:pointer}\
.guide{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;background:#f7f7f8;border-radius:14px;padding:14px;margin:6px 0 14px;max-width:460px}\
.guide figure{margin:0;display:flex;flex-direction:column;align-items:center;gap:6px}\
.guide .lensswatch{max-width:120px}\
.guide figcaption{font-size:12px;font-weight:600}\
.guide figcaption.on{text-decoration:underline;text-underline-offset:3px}\
.tv-hint{margin:14px 0 10px}\
.tints{position:relative}\
/* --- lens-in-frame renders (2B-photos) --- */\
.lensframe{position:relative;margin:0;width:100%;max-width:420px;display:flex;flex-direction:column;align-items:center}\
.lensframe__box{width:100%;aspect-ratio:600/292;border-radius:14px;background:#f3f3f5;overflow:hidden;transition:background .2s}\
.lensframe__box img{display:block;width:100%;height:100%;object-fit:contain;opacity:0;transition:opacity .2s}\
.lensframe.is-loaded .lensframe__box{background:#fff}.lensframe.is-loaded img{opacity:1}\
.lensframe figcaption{font-size:12px;color:#6e6e73;margin-top:6px;text-align:center}\
.guide--renders{max-width:none;grid-template-columns:repeat(3,minmax(0,1fr))}\
.guide--renders .lensframe .lensframe__box{border-radius:10px}\
.guide__more{grid-column:1/-1;justify-self:start;padding:2px 0 0}\
.tv-more{margin:-8px 0 12px;align-self:center}\
.pair__render{align-self:center;max-width:420px}\
.chartdlg{border:none;border-radius:16px;padding:16px 16px 12px;max-width:min(94vw,1100px);width:100%;box-shadow:0 20px 60px rgba(0,0,0,.25)}\
.chartdlg::backdrop{background:rgba(0,0,0,.45)}\
.chartdlg__top{display:flex;justify-content:space-between;align-items:center;gap:12px;margin-bottom:10px}\
.chartdlg__top h3{margin:0;font-size:16px}\
.chartdlg__x{border:none;background:#f3f3f5;border-radius:999px;width:36px;height:36px;font-size:20px;line-height:1;cursor:pointer;color:#1d1d1f}\
.chartdlg__x:focus-visible{outline:2px solid #1d1d1f;outline-offset:2px}\
.chartdlg__scroll{overflow-x:auto;-webkit-overflow-scrolling:touch}\
.chartdlg img{display:block;width:100%;min-width:720px;height:auto}\
.chartdlg__err{font-size:14px;color:#6e6e73;padding:24px 0}\
.pair{display:flex;flex-direction:column;gap:14px;border:1px solid #ececec;border-radius:16px;padding:18px;margin-bottom:14px}\
.pair__row{display:flex;align-items:center;gap:14px}\
.pair__img{width:96px;height:72px;object-fit:contain;background:#f5f5f7;border-radius:10px;flex:0 0 auto}\
.pair__sw{width:96px;height:72px;object-fit:contain;flex:0 0 auto}\
.pair__k{font-size:12px;color:#6e6e73;text-transform:uppercase;letter-spacing:.06em}\
.pair__v{font-weight:600;font-size:16px}\
.pair__s{font-size:13px;color:#6e6e73;margin-top:2px}\
.agbox{display:flex;align-items:flex-start;gap:12px;border:1.5px solid #e6e6e6;border-radius:14px;padding:16px 18px;cursor:pointer;margin:0 0 14px;transition:border-color .15s,box-shadow .15s}\
.agbox.sel{border-color:#1d1d1f;box-shadow:0 0 0 1px #1d1d1f}\
.agbox input{width:20px;height:20px;margin:1px 0 0;accent-color:#1d1d1f;flex:0 0 auto;cursor:pointer}\
.agbox .t{font-weight:600;font-size:15px;display:block}\
.agbox .d{font-size:13px;color:#6e6e73;display:block;margin-top:3px;line-height:1.4}\
.agbox .price{margin-left:auto;font-weight:600;font-size:15px;white-space:nowrap}\
.pdetails{border:1px solid #ececec;border-radius:14px;padding:4px 16px;margin-bottom:14px}\
.pdetails summary{cursor:pointer;font-weight:600;font-size:14px;padding:12px 0;border-radius:6px}\
.pdetails .lines{border-top:none;padding-top:0}\
.pdetails .total{margin-bottom:12px}\
.from{font-size:14px;color:#6e6e73}.from strong{display:block;font-size:22px;color:#1d1d1f;margin-top:2px}.from+.from{margin-top:10px}\
@media(max-width:880px){\
  .cards{grid-template-columns:1fr}\
  .nav__add{flex:1;flex-direction:column;align-items:stretch;gap:4px;max-width:240px}\
  .nav__add [data-add]{max-width:none}\
  .nav__eta{font-size:11px;text-align:center;max-width:none}\
  .cards.cards--compact{grid-template-columns:1fr 1fr;gap:8px}\
  .cards--compact .card{padding:10px 12px}.cards--compact .t{font-size:14px}\
  .card--lg{min-height:0;flex-direction:row;flex-wrap:wrap;align-items:center;column-gap:14px}\
  .card--lg .card__ic{width:40px;height:40px;margin:0}\
  .card--lg .card__b{flex:1;min-width:0}\
  .card--lg .price{margin:0;padding:0}\
  .lensswatch{max-width:200px}\
  .tv-hint{display:none}\
  .tints{display:flex;overflow-x:auto;scroll-snap-type:x mandatory;gap:10px;padding:2px 2px 10px;margin:0 -16px 12px;padding-left:16px;padding-right:16px;scroll-padding:0 16px;-webkit-overflow-scrolling:touch;scrollbar-width:none}\
  .tints::-webkit-scrollbar{display:none}\
  .tint{flex:0 0 78px;scroll-snap-align:center}\
  .lensprev{margin:0 0 12px}\
  .guide .lensswatch{max-width:100px}\
  .lensprev .lensframe,.pair__render{max-width:none}\
  .guide--renders{gap:6px;padding:10px}\
}\
";

  // Build Your Own Pair: the step list depends on the lens program. Prescription orders
  // pick a prescription type, then collect the prescription and a lens material;
  // nonprescription orders skip all three
  // (the lab offers plano lenses in plastic only, so material auto-selects).
  // Anti-glare is an add-on checkbox on the Review step, not a step of its own.
  var STEP_LABELS = { start: 'Frame', lensType: 'Lens Type', rxType: 'Prescription Type', lenses: 'Lenses', prescription: 'Your Prescription', material: 'Lens Material', review: 'Review' };
  var NON_RX = 'Non-Prescription';
  var RX_TYPES = ['Distance (Single Vision)', 'Reading (Single Vision)', 'Progressive'];
  var RX_TYPE_DESCS = {
    'Distance (Single Vision)': 'Clear vision at a distance, such as driving or watching TV.',
    'Reading (Single Vision)': 'Clear near vision for reading, phones, and other close-up tasks.',
    'Progressive': 'Distance, intermediate, and reading in one lens, with no line.'
  };
  // Grouped the way the client's swatch sheet is, sunglass lenses first. Finishes not listed
  // here still render, in a trailing group, so a finish added in admin never disappears silently.
  // Names here are the catalog's; shoppers see the display names (see _fname).
  var FINISH_GROUPS = [
    { title: 'Tinted Sunglass Lenses', finishes: ['Solid Tint', 'Gradient Tint', 'Solid Tint Polarized', 'Gradient Tint Polarized'] },
    { title: 'Mirrored', finishes: ['Solid Mirror', 'Gradient Mirror', 'Polarized Mirror'] },
    { title: 'Everyday lenses', finishes: ['Clear', 'Blue Light Blocker', 'Photochromic'] }
  ];
  // Frame colour dots: the colour words in a frame twin's title, painted from this map.
  var FRAME_PAINT = { Black: '#1d1d1f', Gold: '#c9a45c', Champagne: '#dcc8a0', Tortoise: 'radial-gradient(circle at 30% 30%,#b5793a,#5a3413 70%)', Silver: '#c4c4c8', Gunmetal: '#55585c', Brown: '#6b4a2b' };
  var ICONS = {
    frame: '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20h40"/><path d="M6 20c0 7 2 11 8 11s8-4 8-11"/><path d="M26 20c0 7 2 11 8 11s8-4 8-11"/><path d="M22 22c1-1.3 3-1.3 4 0"/></svg>',
    box: '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 15l18-8 18 8v19l-18 8-18-8z"/><path d="M6 15l18 8 18-8"/><path d="M24 23v19"/><path d="M15 11l18 8v6"/></svg>',
    glasses: '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="13" cy="27" r="8"/><circle cx="35" cy="27" r="8"/><path d="M21 26c2-2 4-2 6 0"/><path d="M5 25L9 14"/><path d="M43 25l-4-11"/></svg>',
    rx: '<svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="10" y="8" width="28" height="34" rx="3"/><path d="M19 8V5h10v3"/><path d="M17 18v12"/><path d="M17 18h5a3 3 0 010 6h-5"/><path d="M21 24l7 8"/><path d="M28 26l-5 6"/></svg>'
  };
  var FINISH_DESCS = {
    'Clear': 'Clear lenses for everyday wear.',
    'Blue Light Blocker': 'Filters blue light from screens.',
    'Photochromic': 'Clear indoors and darkens in sunlight.',
    'Solid Tint': 'One even color across the whole lens, in the shade you choose.',
    'Gradient Tint': 'Darker at the top and fading lighter toward the bottom.',
    'Solid Tint Polarized': 'An even tint with polarization to cut glare off water, roads, and snow.',
    'Gradient Tint Polarized': 'A dark-to-light gradient with polarization to cut glare.',
    'Solid Mirror': 'A reflective mirror finish over a solid tint.',
    'Gradient Mirror': 'A reflective mirror finish over a gradient tint.',
    'Polarized Mirror': 'A reflective mirror finish with polarization for the brightest days.'
  };
  var INTENSITIES = ['Light', 'Medium', 'Dark'];
  // Dark matches the lenses in our sunglasses (the lab's word), so every tinted finish starts there.
  var DEFAULT_INTENSITY = 'Dark';
  // Swatch asset per finish (assets/byo-lens-<key>[-<color>].webp); variant images win when set.
  var FINISH_ASSET = { 'Clear': 'clear', 'Blue Light Blocker': 'bluelight', 'Photochromic': 'photochromic', 'Solid Tint': 'solid', 'Gradient Tint': 'gradient', 'Solid Tint Polarized': 'polarized', 'Gradient Tint Polarized': 'polarized-gradient', 'Solid Mirror': 'mirror', 'Gradient Mirror': 'mirror-gradient', 'Polarized Mirror': 'mirror' };
  var SINGLE_SWATCH = { clear: 1, bluelight: 1 };
  // Lens-in-frame photos (Shopify Files, see dev/byo/prepare_lens_renders.py). Each finish maps
  // to a render family; 'int' = the chosen darkness. Clear and Blue Light Blocker have no
  // renders and keep their swatch. File names:
  //   byop-{set}-{solid|gradient}-{color}-{light|medium|dark}.webp, byop-{set}-mirror-{color}.webp,
  //   byop-{set}-chart-{solid|gradient|mirror}.webp
  var RENDER_FINISH = {
    'Solid Tint': ['solid', 'int'], 'Gradient Tint': ['gradient', 'int'],
    'Solid Tint Polarized': ['solid', 'dark'], 'Gradient Tint Polarized': ['gradient', 'dark'],
    'Solid Mirror': ['mirror'], 'Polarized Mirror': ['mirror'], 'Gradient Mirror': ['mirror'],
    'Photochromic': ['solid', 'medium']
  };
  var renderColor = function (name) { var c = slug(name); return c === 'grey' ? 'gray' : c; };
  var slug = function (s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); };
  var offered = function (programs, program) { return !program || !programs || !programs.length || programs.indexOf(program) > -1; };

  class RxBuilder extends HTMLElement {
    connectedCallback() {
      this.cfg = this._readConfig();
      this._applyFrameTitleOverrides();
      // Finishes hidden from the builder (settings.hiddenFinishes) stay in the catalog.
      var hidden = (this.cfg.settings && this.cfg.settings.hiddenFinishes) || [];
      this.cfg.finishes = (this.cfg.finishes || []).filter(function (f) { return hidden.indexOf(f.name) < 0; });
      this.root = this.attachShadow({ mode: 'open' });
      var p = new URLSearchParams(location.search);
      this._freshState();
      var fh = p.get('frame');
      if (fh) {
        var f = (this.cfg.frames || []).find(function (x) { return x.handle === fh; });
        // If the new-pair flow is gated to "coming soon", a PDP deep-link lands on the first step
        // (the coming-soon notice) instead of jumping into a flow the customer can't complete.
        if (f && f.available) { this.state.flow = 'new'; this.state.frame = f; this.state.stepId = this._newPairOn() ? this._startStep(p) : 'start'; }
        else if (f && this._newPairOn()) this.state.flow = 'new';
      }
      this._deepLinkFrame = fh || null;
      this.render();
      this._loadFrames();
      this._liftA11yWidget();
      // Browser Back from checkout can restore this page from the back/forward cache with the
      // finished build still in memory. That pair is in the cart already, so start a new one.
      var self = this;
      window.addEventListener('pageshow', function (e) {
        if (!e.persisted || !self._handedOff) return;
        self._handedOff = false;
        self._freshState();
        self._lastStep = undefined;
        self.render();
      });
    }
    // A new, empty build. Nothing about the lenses is chosen until the shopper chooses it.
    _freshState() {
      this.state = {
        flow: null,            // 'new' | 'existing'
        program: null,         // 'rx' | 'nonrx'
        frame: null,           // selected frame card (new-frames flow)
        rxMode: 'manual',      // 'manual' | 'photo'
        rxValues: {},
        photo: null,           // File
        pdMode: 'single', pd: {},
        ownFrame: '', ownFrameOther: '',   // re-lens: which frame is being mailed in
        comments: '',
        stepId: 'start',
        bundle: uid()
      };
      this._clearLenses();
      // /pages/prescription-lenses?lens=rx presets the program; the customer can still change it.
      var lens = new URLSearchParams(location.search).get('lens');
      if (lens === 'rx' || lens === 'nonrx') this._setProgram(lens);
    }
    // Every lens choice: lens type, finish, colour, darkness, material and coating.
    _clearLenses() {
      var s = this.state;
      s.program = null;
      s.rxType = null;         // Lens Type variant name (Non-Prescription or a prescription type)
      s.feature = null;        // Lens Finish name
      s.tintColor = null;
      s.intensity = DEFAULT_INTENSITY;
      s.featureDrilled = false;
      s.guideOpen = false;
      s.lensType = null;       // lens material
      s.lensAuto = false;      // material was auto-selected for the program
      s.antiGlare = false;
    }
    // Switching between New frames and Re-lens starts the lenses over, so nothing picked for the
    // other path shows up in the summary or the cart.
    _setFlow(flow) {
      var s = this.state;
      if (s.flow === flow) return;
      s.flow = flow;
      s.frame = null;
      this._clearLenses();
      var lens = new URLSearchParams(location.search).get('lens');
      if (lens === 'rx' || lens === 'nonrx') this._setProgram(lens);
    }
    _startStep(params) {
      var steps = this._steps(), i = parseInt(params.get('start') || '1', 10) || 1;
      return steps[Math.min(Math.max(i, 1), steps.length - 1)];
    }

    // Frame-title overrides, e.g. "The Black Gold Empire" -> "The Gold Empire".
    _applyFrameTitleOverrides() {
      var ov = (this.cfg.settings && this.cfg.settings.frameTitleOverrides) || {};
      (this.cfg.frames || []).forEach(function (f) { if (ov[f.title]) f.title = ov[f.title]; });
    }

    // Frames come from /products/<handle>.js rather than Liquid: all_products is
    // capped at 20 lookups per render, and the components already use most of
    // that budget. Unlisted products still serve their .js endpoint, so this also
    // sidesteps the collection restriction that hid the grid entirely.
    _loadFrames() {
      var handles = this.cfg.frameHandles || [];
      if (!handles.length || (this.cfg.frames && this.cfg.frames.length)) return;
      var self = this;
      var sized = function (u) {
        if (!u) return '';
        return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=600';
      };
      var inventory = window.WPRxFrameInventory;
      var requests = {};
      // One retry for transient failures (throttling, a dropped connection); a 404 means the
      // handle doesn't exist yet, so it is skipped without retrying.
      var fetchProduct = function (handle, retries) {
        return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) {
            if (r.ok) return r.json();
            if (r.status === 404 || !retries) return null;
            return new Promise(function (res) { setTimeout(res, 400); }).then(function () { return fetchProduct(handle, retries - 1); });
          })
          .catch(function () { return retries ? fetchProduct(handle, retries - 1) : null; });
      };
      var getProduct = function (handle) {
        if (!handle) return Promise.resolve(null);
        if (!requests[handle]) requests[handle] = fetchProduct(handle, 1);
        return requests[handle];
      };
      Promise.all(handles.map(function (h) {
        var rule = inventory && inventory.ruleForRx(h);
        return Promise.all([getProduct(h), rule ? getProduct(rule.product) : Promise.resolve(null)])
          .then(function (products) { return { rx: products[0], source: products[1], rule: rule }; });
      })).then(function (list) {
        var seen = {}, frames = [];
        list.forEach(function (entry) {
          var pr = entry.rx;
          if (!pr || !pr.variants || !pr.variants.length) return;
          if (seen[pr.handle]) return;           // a handle can only produce one card
          seen[pr.handle] = 1;
          var chosen = null;
          for (var i = 0; i < pr.variants.length; i++) { if (pr.variants[i].available) { chosen = pr.variants[i]; break; } }
          if (!chosen) chosen = pr.variants[0];
          var angle = self._anglePhoto(entry.source);
          var retailAvailable = entry.rule
            ? inventory.sourceAvailable(entry.source, entry.rule, self.cfg.frameStock)
            : !!chosen.available;
          frames.push({
            id: chosen.id,
            handle: pr.handle,
            // Twin titles end in " Rx" today and " (Custom Build)" after the launch retitle.
            title: String(pr.title || '').replace(/\s+Rx$/, '').replace(/\s*\(Custom Build\)$/, ''),
            // The retail product's "angle" photo when it has one (see _anglePhoto), else the twin's own.
            image: sized(angle || (chosen.featured_image && chosen.featured_image.src) || pr.featured_image || ''),
            angle: !!angle,
            price: (chosen.price || 0) / 100,
            available: !!chosen.available && retailAvailable,
            // Frame cards group twins by retail product (the inventory rule's `product`).
            model: entry.rule ? entry.rule.product : pr.handle,
            modelTitle: entry.source && entry.source.title ? String(entry.source.title) : ''
          });
        });
        if (!frames.length) return;
        self.cfg.frames = frames;
        self._applyFrameTitleOverrides();
        // A ?frame=<handle> deep link couldn't resolve before the fetch finished.
        if (self._deepLinkFrame && !self.state.frame) {
          var f = frames.find(function (x) { return x.handle === self._deepLinkFrame; });
          if (f && f.available && self._newPairOn()) {
            self.state.flow = 'new'; self.state.frame = f;
            self.state.stepId = self._startStep(new URLSearchParams(location.search));
          } else if (f && self._newPairOn() && !self.state.flow) {
            // Out of stock or on preorder: open the new-pair grid with nothing chosen.
            self.state.flow = 'new';
          }
        }
        self.render();
      });
    }

    // A product photo tagged with alt text "angle" is that frame's builder photo (every frame's
    // main image is an angled shot except The Wrap's). Read from the retail product already
    // fetched for stock, so it costs no extra request.
    _anglePhoto(product) {
      var m = product && (product.media || []).find(function (x) { return x.media_type === 'image' && String(x.alt || '').trim().toLowerCase() === 'angle'; });
      return m ? (m.src || (m.preview_image && m.preview_image.src) || '') : '';
    }
    // class="img--angle" for an "angle" photo: it's a larger square on an off-white backdrop, so
    // CSS whitens the backdrop and scales it to sit like the other frames' shots.
    _angleCls(url) {
      var hit = !!url && ((this.cfg.frames || []).some(function (f) { return f.angle && f.image === url; })
        || (this.cfg.relensStyles || []).some(function (r) { return r.angle && r.image === url; }));
      return hit ? ' class="img--angle"' : '';
    }

    _readConfig() {
      try { return JSON.parse(document.getElementById('rx-builder-config').textContent); }
      catch (e) { return { pricing: {}, frames: [], lensTypes: [], finishes: [], materials: [], variantIds: {}, settings: {} }; }
    }
    _newPairOn() { return !!(this.cfg.settings && this.cfg.settings.newPairEnabled === true); }

    /* ---------- catalog ---------- */
    _lensTypeFor(name) { return (this.cfg.lensTypes || []).find(function (t) { return t.name === name; }) || null; }
    // Finishes offered for a program, each with only the colors that program can order.
    _finishes(program) {
      return (this.cfg.finishes || []).map(function (f) {
        return Object.assign({}, f, { colors: (f.colors || []).filter(function (c) { return offered(c.programs, program); }) });
      }).filter(function (f) { return f.colors.length; });
    }
    // The name shoppers see for a finish. The cart keeps the catalog name.
    // Shared defaults (assets/byop-finish-names.js) with the section's overrides on top.
    _fname(name) {
      var o = (this.cfg.settings && this.cfg.settings.finishNames) || {}, N = window.WPByopFinishNames;
      return N ? N.name(name, o) : (o[name] || name);
    }
    // A summary or review line as shoppers read it: the finish line uses the display name.
    _lineLabel(l) {
      var f = l.key === 'finish' && this._finish(this.state.feature);
      return f && l.label.indexOf(f.name) === 0 ? this._fname(f.name) + l.label.slice(f.name.length) : l.label;
    }
    _finish(name, program) {
      return this._finishes(program === undefined ? this.state.program : program).find(function (f) { return f.name === name; }) || null;
    }
    _color() {
      var f = this._finish(this.state.feature), c = this.state.tintColor;
      return f ? (f.colors.find(function (x) { return x.name === c; }) || null) : null;
    }
    _materials(program) {
      return (this.cfg.materials || []).filter(function (m) {
        // No metafield yet: the pricing sheet offers nonprescription lenses in plastic only.
        if (!m.programs || !m.programs.length) return program !== 'nonrx' || /plastic/i.test(m.name);
        return offered(m.programs, program);
      });
    }
    // Lowest price a program's build can start from: its cheapest lens type plus the cheapest
    // finish it can order. null when the catalog offers the program nothing.
    _startingPrice(program) {
      var min = function (list) { var p = list.map(function (x) { return x.price; }).filter(function (n) { return typeof n === 'number'; }); return p.length ? Math.min.apply(null, p) : null; };
      var lt = min((this.cfg.lensTypes || []).filter(function (t) { return offered(t.programs, program); }));
      var fin = min(this._finishes(program));
      return lt === null || fin === null ? null : lt + fin;
    }
    // "From" prices before anything is priced: one per program until a lens type is chosen
    // (nonprescription only on frames that can't take a prescription), then that program's.
    _fromPrices() {
      var s = this.state, self = this, rows = [];
      var progs = s.program ? [s.program] : this._rxBlocked() ? ['nonrx'] : ['rx', 'nonrx'];
      progs.forEach(function (pg) {
        var v = self._startingPrice(pg);
        if (v !== null) rows.push({ label: s.program ? 'Starting at' : pg === 'rx' ? 'Prescription from' : 'Nonprescription from', value: money(v) });
      });
      return rows;
    }
    // Human lens line for the review, e.g. "Purple Solid Tint, Light".
    _lensLine() {
      var s = this.state, f = this._finish(s.feature), c = this._color();
      if (!f) return '';
      return (c && f.colors.length > 1 ? c.name + ' ' : '') + this._fname(f.name) + (f.hasIntensity ? ', ' + s.intensity : '');
    }
    // Frame models for the new-pair grid: one entry per retail product, each with its
    // available colour twins in the configured order.
    _models() {
      var order = [], byKey = {};
      (this.cfg.frames || []).forEach(function (f) {
        if (!f.available) return;
        var k = f.model || f.handle;
        if (!byKey[k]) { byKey[k] = { key: k, title: f.modelTitle || f.title, twins: [] }; order.push(byKey[k]); }
        byKey[k].twins.push(f);
      });
      return order;
    }
    _frameColor(f) {
      var words = String(f.title || '').replace(/^The\s+/, '').split(/\s+/).filter(function (w) { return FRAME_PAINT[w]; });
      return words.length ? words.join(' ') : 'Black';
    }
    _framePaint(f) {
      var words = this._frameColor(f).split(' ');
      if (words.length < 2) return FRAME_PAINT[words[0]];
      // Two-tone frames (Black Gold, Tortoise Gold) split the dot diagonally.
      var flat = function (w) { return w === 'Tortoise' ? '#8a5526' : FRAME_PAINT[w]; };
      return 'linear-gradient(135deg,' + flat(words[0]) + ' 50%,' + flat(words[1]) + ' 50%)';
    }
    _swatch(finishName, colorName, colorObj) {
      if (colorObj && colorObj.image) return colorObj.image;
      var key = FINISH_ASSET[finishName];
      if (!key) return '';
      var base = (this.cfg.settings && this.cfg.settings.swatchBase) || '';
      return base + 'byo-lens-' + key + (SINGLE_SWATCH[key] ? '' : '-' + slug(colorName)) + '.webp';
    }

    /* ---------- lens-in-frame photos ---------- */
    // The render set for this build: the chosen frame, or the frame being sent in. Frames with
    // no renders of their own borrow a close set and say so ("shownOn"). Map: settings.renderSets.
    _renderSet() {
      var map = (this.cfg.settings && this.cfg.settings.renderSets) || {}, s = this.state, e = null;
      if (s.flow === 'existing' && s.ownFrame === 'Other') e = map._other;
      else {
        var h = this._frameHandle();
        if (h) e = map[h];
        // A re-lens style with no frame twin (The Epoch, The Hook Cerakote) borrows the Other set.
        else if (s.flow === 'existing' && s.ownFrame) e = map._other;
      }
      if (typeof e === 'string') return { set: e, shownOn: '' };
      return e && e.set ? { set: e.set, shownOn: e.shownOn || '' } : null;
    }
    // Photo of this frame wearing finish f in colour c at darkness `level`, or '' when there is
    // none (Clear, Blue Light Blocker, an unmapped frame, or a photo that failed to load).
    _renderUrl(f, c, level) {
      var fam = f && RENDER_FINISH[f.name], rs = this._renderSet(), base = this.cfg.settings && this.cfg.settings.renderBase;
      if (!fam || !rs || !base || !c) return '';
      var name = 'byop-' + rs.set + '-' + fam[0] + '-' + renderColor(c.name);
      if (fam[1]) name += '-' + (fam[1] === 'int' ? slug(level || this.state.intensity) : fam[1]);
      var url = base + name + '.webp';
      return this._renderBad && this._renderBad[url] ? '' : url;
    }
    _chartUrl(f) {
      var fam = f && RENDER_FINISH[f.name], rs = this._renderSet(), base = this.cfg.settings && this.cfg.settings.renderBase;
      return fam && rs && base ? base + 'byop-' + rs.set + '-chart-' + fam[0] + '.webp' : '';
    }
    _renderCaption(f) {
      var rs = this._renderSet(), bits = [];
      if (f && f.name === 'Photochromic') bits.push('Shown darkened in sunlight');
      if (rs && rs.shownOn) bits.push('Lens color shown on ' + rs.shownOn);
      return bits.join(' · ');
    }
    // A fixed-ratio box holds the space while the photo loads (no layout jump).
    _renderFigure(url, alt, caption, cls) {
      var ok = this._renderOk && this._renderOk[url];
      return '<figure class="lensframe' + (ok ? ' is-loaded' : '') + (cls ? ' ' + cls : '') + '" data-render>'
        + '<div class="lensframe__box"><img src="' + esc(url) + '" alt="' + esc(alt) + '" width="600" height="292"></div>'
        + (caption ? '<figcaption>' + esc(caption) + '</figcaption>' : '') + '</figure>';
    }
    // Fade each photo in once it loads. A photo that fails is remembered and the step re-renders
    // with the swatch preview in its place, so a missing file never shows as a broken image.
    _bindRenders() {
      var self = this;
      this.root.querySelectorAll('[data-render]').forEach(function (fig) {
        var img = fig.querySelector('img'), url = img && img.getAttribute('src');
        if (!img) return;
        var ok = function () { (self._renderOk || (self._renderOk = {}))[url] = 1; fig.classList.add('is-loaded'); };
        var bad = function () {
          (self._renderBad || (self._renderBad = {}))[url] = 1;
          if (fig.isConnected) self._renderStep();
        };
        if (img.complete) { if (img.naturalWidth) ok(); else bad(); }
        else { img.onload = ok; img.onerror = bad; }
      });
    }
    // Warm the cache for one photo (other darkness levels, the colour under the pointer). No bulk preloading.
    _preload(url) {
      if (!url) return;
      var self = this, seen = this._pre || (this._pre = {});
      if (seen[url] || (this._renderOk && this._renderOk[url])) return;
      seen[url] = 1;
      var im = new Image();
      im.onload = function () { (self._renderOk || (self._renderOk = {}))[url] = 1; };
      im.onerror = function () { (self._renderBad || (self._renderBad = {}))[url] = 1; };
      im.src = url;
    }

    /* ---------- program + frame rules ---------- */
    _frameHandle() {
      var s = this.state;
      if (s.flow === 'new' && s.frame) return s.frame.handle;
      if (s.flow === 'existing' && s.ownFrame) {
        var f = (this.cfg.frames || []).find(function (x) { return x.title === s.ownFrame; });
        return f ? f.handle : null;
      }
      return null;
    }
    // Frames listed in settings.nonrxOnlyHandles only take nonprescription lenses. The list is
    // empty today (The Wrap takes both since 2026-09-29) but kept for a future frame.
    _rxBlocked() {
      var h = this._frameHandle();
      return !!h && ((this.cfg.settings && this.cfg.settings.nonrxOnlyHandles) || []).indexOf(h) > -1;
    }
    // Frames the lab can only fit within a sphere range (settings.limitedRxHandles, e.g. The Wrap:
    // +6.00 to -6.00). Returns the limit for the chosen frame, or 0 when it has none. Matches the
    // new-pair twin or re-lens twin handle, or the re-lens retail style by title.
    _rangeLimit() {
      var st = this.cfg.settings || {}, list = st.limitedRxHandles || [], lim = parseFloat(st.sphereLimit);
      if (!list.length || !(lim > 0)) return 0;
      var s = this.state, h = this._frameHandle();
      if (h && list.indexOf(h) > -1) return lim;
      if (s.flow === 'existing' && s.ownFrame && (this.cfg.relensStyles || []).some(function (r) { return r.title === s.ownFrame && list.indexOf(r.handle) > -1; })) return lim;
      return 0;
    }
    _rangeNote(lim) {
      var n = lim.toFixed(2);
      return 'Suitable for prescription lenses with a sphere range of +' + n + ' to -' + n + '.';
    }
    // The note for a frame card: the twin handle or the re-lens style handle is in the list.
    _cardRangeNote(handles) {
      var st = this.cfg.settings || {}, list = st.limitedRxHandles || [], lim = parseFloat(st.sphereLimit);
      if (!(lim > 0) || !handles.some(function (h) { return h && list.indexOf(h) > -1; })) return '';
      return '<span class="fnote">' + esc(this._rangeNote(lim)) + '</span>';
    }
    _frameTitle() {
      var s = this.state;
      return s.flow === 'new' && s.frame ? s.frame.title : (s.ownFrame && s.ownFrame !== 'Other' ? s.ownFrame : 'this frame');
    }
    _setProgram(program) {
      var s = this.state;
      s.program = program;
      if (program === 'nonrx') s.rxType = NON_RX;
      else if (s.rxType === NON_RX) s.rxType = null;
      // Drop selections this program can't order (e.g. Yellow mirror is nonprescription only).
      if (s.feature) {
        var f = this._finish(s.feature, program);
        if (!f) { s.feature = null; s.tintColor = null; s.featureDrilled = false; }
        else if (s.tintColor && !f.colors.some(function (c) { return c.name === s.tintColor; })) s.tintColor = null;
      }
      var mats = this._materials(program);
      if (s.lensAuto || (s.lensType && !mats.some(function (m) { return m.name === s.lensType; }))) { s.lensType = null; s.lensAuto = false; }
      if (program === 'nonrx' && mats.length === 1) { s.lensType = mats[0].name; s.lensAuto = true; }
    }

    /* ---------- steps ---------- */
    _steps() {
      var s = this.state, out = ['start', 'lensType'];
      if (s.program !== 'nonrx') out.push('rxType');
      out.push('lenses');
      if (s.program !== 'nonrx') out.push('prescription');
      if (!(s.program === 'nonrx' && this._materials('nonrx').length <= 1)) out.push('material');
      out.push('review');
      return out;
    }
    _stepIndex() { var i = this._steps().indexOf(this.state.stepId); return i < 0 ? 0 : i; }
    _go(delta) {
      var steps = this._steps(), i = this._stepIndex() + delta;
      this.state.stepId = steps[Math.min(Math.max(i, 0), steps.length - 1)];
    }

    /* ---------- frame discount ---------- */
    _discPct() { var p = this.cfg.settings.frameDiscountPercent; return (typeof p === 'number') ? p : 30; }
    _disc(price) { return Math.round((price || 0) * (100 - this._discPct())) / 100; }
    _aid(item) { return item.variantId || this._vid(item.key); }

    /* ---------- pricing ---------- */
    lineItems() {
      var s = this.state, pr = this.cfg.pricing || {}, out = [];
      if (s.flow === 'new' && s.frame) out.push({ key: 'frame', variantId: s.frame.id, label: s.frame.title, price: this._disc(s.frame.price), fullPrice: s.frame.price });
      // Lens lines only exist once a lens type is chosen in this build (see _clearLenses).
      if (!s.program) return out;
      if (s.rxType) {
        var lt = this._lensTypeFor(s.rxType);
        out.push({ key: 'rxType|' + s.rxType, label: s.rxType === NON_RX ? 'Nonprescription lenses' : s.rxType, price: lt ? lt.price : 0 });
      }
      var f = this._finish(s.feature), c = this._color();
      if (f && c) {
        var bits = [];
        if (f.colors.length > 1) bits.push(c.name);
        if (f.hasIntensity) bits.push(s.intensity);
        out.push({ key: 'finish', variantId: c.id, label: f.name + (bits.length ? ' (' + bits.join(', ') + ')' : ''), price: f.price });
      }
      if (s.lensType) {
        var m = (this.cfg.materials || []).find(function (x) { return x.name === s.lensType; });
        out.push({ key: 'lensType|' + s.lensType, label: s.lensType, price: m ? m.price : 0 });
      }
      if (s.antiGlare) out.push({ key: 'antiGlare|Anti-Glare Coating', label: 'Anti-Glare Coating', price: pr.antiGlare || 0 });
      return out;
    }
    total() { return this.lineItems().reduce(function (a, l) { return a + l.price; }, 0); }

    /* ---------- validation ---------- */
    canAdvance() {
      var s = this.state;
      switch (s.stepId) {
        case 'start': return s.flow === 'existing' ? !!(s.ownFrame && (s.ownFrame !== 'Other' || (s.ownFrameOther || '').trim())) : !!(this._newPairOn() && s.frame && s.frame.available);
        case 'lensType': return !!s.program && !(s.program === 'rx' && this._rxBlocked());
        case 'rxType': return RX_TYPES.indexOf(s.rxType) > -1;
        case 'lenses': { var f = this._finish(s.feature); return !!(f && this._color() && (!f.hasIntensity || s.intensity)); }
        case 'prescription': return this._rxIssues().length === 0;
        case 'material': return !!s.lensType;
      }
      return true;
    }

    // Lab-grade validation for the prescription step. Returns a list of human-readable issues
    // (empty = valid). Photo mode only needs a valid file; manual mode range-checks every value;
    // PD is always required for prescription lenses.
    _rxIssues() {
      var s = this.state, v = s.rxValues || {}, errs = [];
      if (s.program === 'nonrx') return errs;
      function num(x) { if (x === undefined || x === null || String(x).trim() === '') return null; var n = parseFloat(String(x).replace(/\s|\+/g, '')); return isNaN(n) ? NaN : n; }
      if (s.rxMode === 'photo') {
        if (!s.photo) errs.push('Attach a photo or PDF of your prescription.');
      } else {
        ['od', 'os'].forEach(function (eye) {
          var L = eye.toUpperCase();
          var sph = num(v[eye + '_sph']);
          if (sph === null) errs.push(L + ' SPH is required.');
          else if (isNaN(sph) || sph < -20 || sph > 20) errs.push(L + ' SPH must be a number between -20 and +20.');
          var cyl = num(v[eye + '_cyl']);
          if (cyl !== null && (isNaN(cyl) || cyl < -10 || cyl > 10)) errs.push(L + ' CYL must be between -10 and +10.');
          var axis = num(v[eye + '_axis']);
          if (cyl !== null && !isNaN(cyl) && cyl !== 0) {
            if (axis === null) errs.push(L + ' AXIS is required when CYL is entered.');
            else if (isNaN(axis) || axis < 0 || axis > 180) errs.push(L + ' AXIS must be between 0 and 180.');
          } else if (axis !== null && (isNaN(axis) || axis < 0 || axis > 180)) {
            errs.push(L + ' AXIS must be between 0 and 180.');
          }
          var add = num(v[eye + '_add']);
          if (add !== null && (isNaN(add) || add < 0 || add > 4)) errs.push(L + ' ADD must be between 0 and +4.');
          if (s.rxType === 'Progressive' && (add === null || isNaN(add) || add <= 0)) errs.push(L + ' ADD power is required for progressive lenses.');
        });
        // Limited-range frames (The Wrap): each eye's SPH must also fit the lab's limit.
        var lim = this._rangeLimit();
        if (lim && ['od', 'os'].some(function (eye) { var x = num(v[eye + '_sph']); return x !== null && !isNaN(x) && x >= -20 && x <= 20 && (x < -lim || x > lim); })) {
          var n = lim.toFixed(2);
          errs.push(this._frameTitle() + ' fits prescriptions with a sphere between +' + n + ' and -' + n + '. For a stronger prescription, choose another frame or contact us.');
        }
      }
      // PD is required: the lab can't position the optical centres without it.
      if (s.pdMode === 'single') {
        var p = num(s.pd.single);
        if (p === null) errs.push('Your PD is required. It\'s on your prescription, or measure it in a minute.');
        else if (isNaN(p) || p < 40 || p > 80) errs.push('PD must be between 40 and 80 mm.');
      } else {
        var rt = num(s.pd.right), lt = num(s.pd.left);
        if (rt === null || lt === null) errs.push('Enter both right and left PD. Each eye is measured from the bridge of your nose.');
        else { if (isNaN(rt) || rt < 20 || rt > 40) errs.push('Right PD must be between 20 and 40 mm.'); if (isNaN(lt) || lt < 20 || lt > 40) errs.push('Left PD must be between 20 and 40 mm.'); }
      }
      return errs;
    }
    // Update the inline issue list in place (no re-render) so input focus isn't lost while typing.
    _refreshRxHint() {
      var el = this.root.querySelector('.rx-hint-wrap'); if (!el) return;
      var issues = this._rxIssues();
      var show = this.state.rxTouched && issues.length;
      el.style.display = show ? 'block' : 'none';
      el.innerHTML = show ? issues.map(function (e) { return '<div>• ' + esc(e) + '</div>'; }).join('') : '';
    }

    /* ---------- render ---------- */
    render() {
      this.root.innerHTML = '<style>' + CSS + '</style><div class="wrap"><div class="main"></div>' + this._summary() + '</div>' + this._msheet() + this._chartDialog() + this._topbar();
      this._renderStep();
      this._bindNav();
      this._bindMobile();
    }
    _renderStep() {
      var el = this.root.querySelector('.main'), s = this.state, steps = this._steps();
      if (steps.indexOf(s.stepId) < 0) s.stepId = steps[Math.min(this._lastIndex || 0, steps.length - 1)];
      var idx = this._stepIndex();
      var stepper = '<div class="stepper">' + steps.map(function (_, i) { return '<b class="' + (i < idx ? 'done' : i === idx ? 'active' : '') + '"></b>'; }).join('') + '</div>';
      var head = '<h1>' + esc(s.flow === 'existing' ? this.cfg.settings.headingExisting : this.cfg.settings.headingNew) + '</h1>' + '<div class="muted">Step ' + (idx + 1) + ' of ' + steps.length + ' · ' + STEP_LABELS[s.stepId] + '</div>' + stepper;
      // Animate only on a real step change (not on in-step re-renders from selecting options).
      var anim = (this._lastStep !== undefined && this._lastStep !== s.stepId) ? (this._dir === 'back' ? ' step--back' : ' step--fwd') : '';
      // Re-rendering replaces the buttons, so remember which control had keyboard focus.
      var refocus = this._focusKey();
      // The action row sits outside the animated step so its fixed/sticky position never
      // resolves against a transformed ancestor mid-animation.
      el.innerHTML = '<div class="step' + anim + '">' + head + this['_step_' + s.stepId]() + '</div>' + this._nav();
      this._lastStep = s.stepId;
      this._lastIndex = idx;
      this._bindStep();
      this._refreshSummary();
      this._liftA11yWidget();
      if (refocus) { var back = this.root.querySelector(refocus); if (back) { try { back.focus({ preventScroll: true }); } catch (e) { back.focus(); } } }
    }
    // The site's accessiBe button is fixed to the bottom-right corner, where the pinned action
    // row sits on phones. On this page only, lift it above the row (it stays visible and usable).
    // The button lives in accessiBe's open shadow root, so the rule goes in there; the row's
    // height reaches it through a custom property on the host. Harmless if accessiBe changes.
    _liftA11yWidget() {
      var self = this;
      // accessiBe mounts several <access-widget-ui> hosts; the button is in one of them.
      var host = Array.prototype.find.call(document.querySelectorAll('access-widget-ui'), function (h) { return h.shadowRoot && h.shadowRoot.querySelector('.trigger-button'); });
      var sr = host && host.shadowRoot;
      if (!sr) {
        // The widget loads async after the page; check often (cheap) for up to ~30s so the lift
        // lands as soon as its button appears.
        if (!this._a11yPoll && (this._a11yTries || 0) < 200) {
          this._a11yTries = (this._a11yTries || 0) + 1;
          this._a11yPoll = setTimeout(function () { self._a11yPoll = null; self._liftA11yWidget(); }, 150);
        }
        return;
      }
      if (!sr.getElementById('wp-byop-lift')) {
        var st = document.createElement('style');
        st.id = 'wp-byop-lift';
        st.textContent = '@media (max-width:880px){.trigger-button{bottom:calc(var(--wp-byop-lift, 76px) + 10px)!important}}';
        sr.appendChild(st);
      }
      var nav = this.root && this.root.querySelector('.nav');
      if (nav && nav.offsetHeight) host.style.setProperty('--wp-byop-lift', nav.offsetHeight + 'px');
      if (!this._a11yResize) { this._a11yResize = true; window.addEventListener('resize', function () { self._liftA11yWidget(); }); }
    }
    // A selector for the focused control built from its data-* attributes (they identify the
    // option, dot or button), so the same control can take focus back after a re-render.
    _focusKey() {
      var a = this.root && this.root.activeElement;
      if (!a || !a.attributes) return null;
      var sel = Array.prototype.filter.call(a.attributes, function (x) { return /^data-/.test(x.name); })
        .map(function (x) { return '[' + x.name + '="' + String(x.value).replace(/["\\]/g, '\\$&') + '"]'; }).join('');
      return sel || null;
    }

    _step_start() {
      var s = this.state, frames = this.cfg.frames || [];
      var incl = '<div class="rx-incl"><strong>What\'s included with every lens?</strong><br>All William Painter lenses come standard with scratch resistance and UV protection at no additional cost.</div>';
      var flowCard = function (flow, icon, title, desc) {
        return '<button type="button" class="card ' + (s.flow === flow ? 'sel' : '') + '" data-flow="' + flow + '" aria-pressed="' + (s.flow === flow) + '">'
          + '<span class="card__ic">' + ICONS[icon] + '</span><span class="t">' + title + '</span><span class="d">' + desc + '</span></button>';
      };
      // Once a path is chosen the cards shrink to a compact switch so the frames sit higher.
      var flowSel = '<div class="cards' + (s.flow ? ' cards--compact' : '') + '">'
        + flowCard('new', 'frame', 'New frames', 'Pick a frame and we\'ll build it with the lenses you choose.')
        + flowCard('existing', 'box', 'Re-lens my frames', 'Already own a William Painter pair? Send it in and we\'ll fit fresh lenses.')
        + '</div>'
        + '<p class="eta">' + esc(this._delivery(true)) + '</p>';
      var intro = '<p class="both">Both options are available with prescription or nonprescription lenses.</p>';
      if (!s.flow) return '<h2>Where do we start?</h2>' + flowSel + intro + incl;
      // Re-lens flow: the customer tells us which frame is coming so the lab can prep the lens shape.
      if (s.flow === 'existing') {
        // Previously nothing about the frame was captured and the lab had to email and ask (real order #172066).
        // Frame Model keeps the value the old dropdown wrote: the frame twin's title, or the typed text for Other.
        var ownSel = '<h3 class="ownh" id="rx-own-l">Which frame are you sending in?</h3>' + this._ownFrameGrid()
          + (s.ownFrame === 'Other'
              ? '<div class="field"><label for="rx-own-other">Tell us the model, or describe it</label><input id="rx-own-other" data-ownframeother placeholder="For example, The Hook in black" value="' + esc(s.ownFrameOther || '') + '"></div>'
              : '');
        return '<h2>Re-lens your William Painter frames</h2>' + flowSel + '<div class="note">' + esc(this._sendinNote()) + ' You\'re only paying for the lenses, with no frame charge.</div>' + ownSel + incl;
      }
      // new-pair flow
      if (!this._newPairOn()) {
        return flowSel + '<div class="rx-soon"><div class="rx-soon-badge">Coming soon</div><h3>New pairs are on the way</h3><p>' + esc(this.cfg.settings.comingSoonText || 'Ordering a brand-new pair is coming soon. Already own a William Painter frame? Choose Re-lens my frames and we\'ll fit it with fresh lenses.') + '</p></div>' + incl;
      }
      var self = this, pct = this._discPct();
      // Frames arrive asynchronously (/products/<handle>.js). Show a brief loading
      // line rather than an empty grid if the buyer reaches this step first.
      if (!frames.length && (this.cfg.frameHandles || []).length) {
        return '<h2>Choose your frame</h2>' + flowSel + '<p class="muted">Loading frames…</p>' + incl;
      }
      // One card per frame model. Its colour dots swap the photo, price and selection between the
      // model's frame twins. Only in-stock colours show, and a model with none drops out.
      var nonrxOnly = (this.cfg.settings && this.cfg.settings.nonrxOnlyHandles) || [];
      var shown = this._modelShown || (this._modelShown = {});
      var grid = '<div class="grid">' + this._models().map(function (m) {
        var f = m.twins.find(function (t) { return s.frame && s.frame.id === t.id; })
          || m.twins.find(function (t) { return String(t.id) === String(shown[m.key]); })
          || m.twins[0];
        var sel = !!(s.frame && s.frame.id === f.id);
        // pct 0 = the collection's prices already include any discount, so show one clean price.
        var price = pct > 0 ? ('<s>' + money(f.price) + '</s> <b>' + money(self._disc(f.price)) + '</b>') : ('<b>' + money(f.price) + '</b>');
        var media = f.image ? ('<img src="' + esc(f.image) + '"' + self._angleCls(f.image) + ' alt="">') : '<span class="frame__ph"></span>';
        var color = self._frameColor(f);
        var tag = (m.twins.some(function (t) { return nonrxOnly.indexOf(t.handle) > -1; }) ? '<span class="ftag">Nonprescription only</span>' : '')
          + self._cardRangeNote(m.twins.map(function (t) { return t.handle; }).concat([m.key]));
        var dots = m.twins.length > 1 ? '<div class="fdots" role="group" aria-label="' + esc(m.title) + ' frame colors">' + m.twins.map(function (t) {
          var on = t.id === f.id;
          return '<button type="button" class="fdot' + (on ? ' sel' : '') + '" data-fdot="' + t.id + '" data-model="' + esc(m.key) + '" aria-pressed="' + on + '" aria-label="' + esc(self._frameColor(t)) + '" title="' + esc(self._frameColor(t)) + '" style="background:' + self._framePaint(t) + '"></button>';
        }).join('') + '</div>' : '';
        return '<div class="frame ' + (sel ? 'sel' : '') + '">'
          + '<button type="button" class="frame__pick" data-card="' + f.id + '" aria-pressed="' + sel + '" aria-label="' + esc(m.title + ', ' + color + ', ' + money(pct > 0 ? self._disc(f.price) : f.price)) + '">'
          + media
          + '<div class="t">' + esc(m.title) + '</div>'
          + '<div class="ft">' + price + '</div>'
          + tag
          + '</button>'
          + '<div class="frame__meta">' + dots + '<span class="fcolor">' + esc(color) + '</span></div>'
          + '</div>';
      }).join('') + '</div>';
      return '<h2>Choose your frame</h2>' + flowSel
        + '<p class="muted">Select your frame. You will choose your lenses in the next steps.</p>'
        + grid + incl;
    }

    // Re-lens frame cards: every sunglass style (settings.relensStyles, from the sunglasses
    // collection) whatever its stock, one card per style, with colour dots where the style has
    // frame twins. Twins whose style isn't in the collection still get a card.
    _relensModels() {
      var byModel = {}, order = [], seen = {}, out = [];
      (this.cfg.frames || []).forEach(function (f) {
        var k = f.model || f.handle;
        if (!byModel[k]) { byModel[k] = []; order.push(k); }
        byModel[k].push(f);
      });
      (this.cfg.relensStyles || []).forEach(function (st) {
        seen[st.handle] = 1;
        out.push({ key: st.handle, title: st.title, image: st.image, twins: byModel[st.handle] || [] });
      });
      order.forEach(function (k) {
        if (seen[k]) return;
        var t = byModel[k];
        out.push({ key: k, title: t[0].modelTitle || t[0].title, image: t[0].image, twins: t });
      });
      return out;
    }
    _ownFrameGrid() {
      var s = this.state, self = this;
      // The card values are frame twin titles, so wait for the twins before offering them.
      if (!(this.cfg.frames || []).length && (this.cfg.frameHandles || []).length) return '<p class="muted">Loading frames…</p>';
      var nonrxOnly = (this.cfg.settings && this.cfg.settings.nonrxOnlyHandles) || [];
      var shown = this._ownShown || (this._ownShown = {});
      var cards = this._relensModels().map(function (m) {
        var twin = m.twins.find(function (t) { return t.title === s.ownFrame; })
          || m.twins.find(function (t) { return t.title === shown[m.key]; })
          || m.twins[0] || null;
        var value = twin ? twin.title : m.title;
        var sel = !!s.ownFrame && s.ownFrame === value;
        var multi = m.twins.length > 1;
        // The retail photo; a multi-colour style shows the chosen colour's photo.
        var img = (multi && twin && twin.image) || m.image || (twin && twin.image) || '';
        var media = img ? '<img src="' + esc(img) + '"' + self._angleCls(img) + ' alt="" loading="lazy">' : '<span class="frame__ph"></span>';
        var color = twin ? self._frameColor(twin) : '';
        var tag = (twin && nonrxOnly.indexOf(twin.handle) > -1 ? '<span class="ftag">Nonprescription only</span>' : '')
          + self._cardRangeNote(m.twins.map(function (t) { return t.handle; }).concat([m.key]));
        var dots = multi ? '<div class="fdots" role="group" aria-label="' + esc(m.title) + ' frame colors">' + m.twins.map(function (t) {
          var on = t.title === value;
          return '<button type="button" class="fdot' + (on ? ' sel' : '') + '" data-owndot="' + esc(t.title) + '" data-ownmodel="' + esc(m.key) + '" aria-pressed="' + (on && sel) + '" aria-label="' + esc(self._frameColor(t)) + '" title="' + esc(self._frameColor(t)) + '" style="background:' + self._framePaint(t) + '"></button>';
        }).join('') + '</div>' : '';
        return '<div class="frame ' + (sel ? 'sel' : '') + '">'
          + '<button type="button" class="frame__pick" data-own="' + esc(value) + '" aria-pressed="' + sel + '" aria-label="' + esc(m.title + (multi ? ', ' + color : '')) + '">'
          + media + '<div class="t">' + esc(m.title) + '</div>' + tag + '</button>'
          + '<div class="frame__meta">' + dots + (multi ? '<span class="fcolor">' + esc(color) + '</span>' : '') + '</div>'
          + '</div>';
      });
      var other = s.ownFrame === 'Other';
      cards.push('<div class="frame ' + (other ? 'sel' : '') + '"><button type="button" class="frame__pick" data-own="Other" aria-pressed="' + other + '">'
        + '<span class="frame__ph frame__ph--other" aria-hidden="true">?</span><div class="t">Other / not sure</div></button><div class="frame__meta"></div></div>');
      return '<div class="grid" role="group" aria-labelledby="rx-own-l">' + cards.join('') + '</div>';
    }

    // Page 2: prescription or nonprescription, two cards and no prices (the summary shows the
    // $55 once Nonprescription is chosen). The prescription types are the next step.
    _step_lensType() {
      var s = this.state, nrx = this._lensTypeFor(NON_RX), blocked = this._rxBlocked();
      var lim = this._rangeLimit();
      var card = function (program, icon, title, sub, disabled, note) {
        return '<button type="button" class="card card--lg ltype ' + (s.program === program ? 'sel' : '') + '"' + (disabled ? ' disabled' : '') + ' data-program="' + program + '" aria-pressed="' + (s.program === program) + '">'
          + '<span class="card__ic">' + ICONS[icon] + '</span>'
          + '<span class="card__b"><span class="t">' + esc(title) + '</span><span class="d" style="display:block;margin-top:4px">' + esc(sub) + '</span>'
          + (note ? '<span class="fnote">' + esc(note) + '</span>' : '') + '</span></button>';
      };
      return '<h2>Lens type</h2><div class="cards">'
        + (nrx ? card('nonrx', 'glasses', 'Nonprescription lenses', 'Custom tints, mirrors, and polarized lenses with no prescription.', false) : '')
        + card('rx', 'rx', 'Prescription lenses', blocked ? 'Prescription lenses aren\'t available for ' + this._frameTitle() + '.' : 'Built to your prescription, from single vision to progressive.', blocked, !blocked && lim ? this._rangeNote(lim) : '')
        + '</div>';
    }
    _step_rxType() {
      var types = {}, self = this;
      RX_TYPES.forEach(function (name) { var t = self._lensTypeFor(name); if (t) types[name] = t.price; });
      return '<h2>Prescription type</h2>' + this._optList('rxType', types, RX_TYPE_DESCS);
    }

    _step_lenses() {
      var s = this.state, self = this, list = this._finishes(s.program);
      if (!list.length) return '<h2>Lenses</h2><div class="rx-hint">Lens options aren\'t set up yet. Please check back soon.</div>';
      var f = this._finish(s.feature);
      if (s.featureDrilled && f) return this._tintView(f);
      var used = {}, html = '';
      var groups = FINISH_GROUPS.concat([{ title: 'More lenses', finishes: list.map(function (x) { return x.name; }) }]);
      groups.forEach(function (g) {
        var rows = g.finishes.map(function (n) { return list.find(function (x) { return x.name === n; }); })
          .filter(function (x) { return x && !used[x.name]; });
        if (!rows.length) return;
        rows.forEach(function (x) { used[x.name] = 1; });
        html += '<h2' + (html ? ' style="margin-top:22px"' : '') + '>' + esc(g.title) + '</h2><div class="opts">'
          + rows.map(function (x) { return self._optRow('feature', x.name, x.price, FINISH_DESCS[x.name], self._finishThumb(x), self._colorDots(x), self._fname(x.name)); }).join('') + '</div>';
      });
      return html;
    }
    // Every colour as a dot, plus a count, for multi-colour finishes. The finish's colours are
    // already filtered to the program, so the count matches what can be ordered.
    _colorDots(f) {
      var self = this, n = f.colors.length;
      if (n < 2) return null;
      return {
        count: n + ' colors',
        dots: '<span class="cdots" aria-hidden="true">' + f.colors.map(function (c) {
          return '<span class="cdot" style="background-image:url(\'' + esc(self._swatch(f.name, c.name, c)) + '\')"></span>';
        }).join('') + '</span>'
      };
    }
    // Clear and Blue Light Blocker swatches are near-white: give them a soft grey tile.
    _clearish(f) { return !!(f && SINGLE_SWATCH[FINISH_ASSET[f.name]]); }
    _finishThumb(f) {
      var c = f.colors[0];
      return '<img class="opt__sw' + (this._clearish(f) ? ' sw--clear' : '') + '" src="' + esc(this._swatch(f.name, c.name, c)) + '" alt="">';
    }
    // Focused picker for a finish: color swatches, tint intensity, and a live lens preview.
    _tintView(f) {
      var s = this.state, self = this;
      var current = this._color() || f.colors[0];
      var swatches = f.colors.length > 1 ? '<div class="tints" role="group" aria-label="Lens color">' + f.colors.map(function (c) {
        var on = s.tintColor === c.name;
        return '<button type="button" class="tint ' + (on ? 'sel' : '') + '" data-tint="' + esc(c.name) + '" aria-pressed="' + on + '"><img class="tint__render" src="' + esc(self._swatch(f.name, c.name, c)) + '" alt=""><span class="tint__n">' + esc(c.name) + '</span></button>';
      }).join('') + '</div>' : '';
      // Order on every screen: photo, then darkness (Light / Medium / Dark swaps the photo), then colours.
      // Darkness sits right under the preview. The guide shows the chosen colour at all three
      // levels with the same treatment as the preview (the lab's comparison charts replace it later).
      var intensity = '';
      if (f.hasIntensity) {
        intensity = '<div class="tv-dark"><div class="field"><label id="rx-dark-l">Tint darkness</label><div class="chips" role="group" aria-labelledby="rx-dark-l">' + INTENSITIES.map(function (i) {
          var on = s.intensity === i;
          return '<button type="button" class="chip ' + (on ? 'sel' : '') + '" data-intensity="' + i + '" aria-pressed="' + on + '">' + i + '</button>';
        }).join('') + '</div></div>'
          + '<p class="muted tv-darknote">Dark is the same as the lenses in our sunglasses. Light and Medium let more light through.</p>'
          + '<button type="button" class="linkbtn" data-guide aria-expanded="' + !!s.guideOpen + '" aria-controls="rx-guide">' + (s.guideOpen ? 'Hide the darkness guide' : 'See the darkness guide') + '</button>'
          + (s.guideOpen ? this._guideMarkup(f, current) : '')
          + '</div>';
      }
      // Mirrors have no darkness guide, so their chart link sits under the photo.
      var chart = this._chartUrl(f);
      var more = !f.hasIntensity && chart && this._renderUrl(f, current) && f.colors.length > 1
        ? '<a class="linkbtn tv-more" href="' + esc(chart) + '" target="_blank" rel="noopener" data-chart="' + esc(this._fname(f.name)) + '">See every color</a>' : '';
      return '<div class="tintview"><button type="button" class="linkback" data-featureback>‹ Change lenses</button>'
        + '<h2>' + esc(this._fname(f.name)) + '</h2>'
        + '<p class="muted">' + esc(FINISH_DESCS[f.name] || '') + ' ' + (f.price ? '+' + money(f.price) : 'Included') + '</p>'
        + '<div class="lensprev">' + this._lensVisual(f, current) + '</div>'
        + more
        + intensity
        + (f.colors.length > 1 ? '<p class="muted tv-hint">Tap a color to preview it.</p>' : '')
        + swatches + '</div>';
    }
    // The darkness guide: this colour on this frame at all three levels, plus the full chart.
    // Without photos it falls back to the swatch at three opacities.
    _guideMarkup(f, c) {
      var s = this.state, self = this, chart = this._chartUrl(f);
      var photos = INTENSITIES.every(function (i) { return self._renderUrl(f, c, i); });
      return '<div class="guide' + (photos ? ' guide--renders' : '') + '" id="rx-guide">' + INTENSITIES.map(function (i) {
        var vis = photos ? self._renderFigure(self._renderUrl(f, c, i), '', '') : self._lensPreviewMarkup(f, c, i, true);
        return '<figure>' + vis + '<figcaption' + (s.intensity === i ? ' class="on"' : '') + '>' + i + '</figcaption></figure>';
      }).join('')
        + (photos && chart ? '<a class="linkbtn guide__more" href="' + esc(chart) + '" target="_blank" rel="noopener" data-chart="' + esc(self._fname(f.name)) + '">See every color</a>' : '')
        + '</div>';
    }
    // Preview for the tint picker: the chosen frame wearing the chosen lens when a photo exists,
    // otherwise the loose-lens swatch.
    _lensVisual(f, c, level) {
      var url = this._renderUrl(f, c, level);
      if (!url) return this._lensPreviewMarkup(f, c, level);
      return this._renderFigure(url, c.name + ' ' + this._fname(f.name) + ' lenses in ' + this._frameTitle(), this._renderCaption(f));
    }
    // Loose-lens swatch preview (Clear, Blue Light Blocker, and the fallback for a missing photo).
    _lensPreviewMarkup(f, c, level, decorative) {
      var cls = 'lensswatch' + (f.hasIntensity ? ' int-' + slug(level || this.state.intensity) : '');
      return '<div class="' + cls + '"><img src="' + esc(this._swatch(f.name, c.name, c)) + '" alt="' + (decorative ? '' : esc(c.name + ' ' + this._fname(f.name) + ' lens')) + '"></div>';
    }
    _step_prescription() {
      var s = this.state, acc = this.cfg.settings.accupdUrl, lim = this._rangeLimit();
      var modeT = (lim ? '<p class="muted rx-range">' + esc(this._frameTitle() + ': ' + this._rangeNote(lim).replace(/^S/, 's')) + '</p>' : '') + '<div class="toggle">'
        + '<button class="opt ' + (s.rxMode === 'manual' ? 'sel' : '') + '" data-rxmode="manual"><span class="t">Enter prescription</span></button>'
        + '<button class="opt ' + (s.rxMode === 'photo' ? 'sel' : '') + '" data-rxmode="photo"><span class="t">Upload a photo</span></button>'
        + '</div>';
      var body;
      if (s.rxMode === 'photo') {
        body = '<div class="field"><label>Prescription photo or PDF</label><input type="file" id="rxphoto" accept="image/*,.pdf"><div class="muted" style="margin-top:6px">JPG, PNG, HEIC or PDF · up to 15 MB</div></div>'
          + (s.photoError ? '<div class="err" style="display:block">' + esc(s.photoError) + '</div>' : (s.photo ? '<div class="muted">Selected: ' + esc(s.photo.name) + '</div>' : ''));
      } else {
        var row = function (eye) {
          return '<div class="rx-grid"><div class="field"><label>' + eye.toUpperCase() + ' SPH</label><input data-rx="' + eye + '_sph" value="' + esc(s.rxValues[eye + '_sph'] || '') + '"></div>'
            + '<div class="field"><label>CYL</label><input data-rx="' + eye + '_cyl" value="' + esc(s.rxValues[eye + '_cyl'] || '') + '"></div>'
            + '<div class="field"><label>AXIS</label><input data-rx="' + eye + '_axis" value="' + esc(s.rxValues[eye + '_axis'] || '') + '"></div>'
            + '<div class="field"><label>ADD</label><input data-rx="' + eye + '_add" value="' + esc(s.rxValues[eye + '_add'] || '') + '"></div></div>';
        };
        body = '<div class="muted" style="margin-bottom:6px">Right eye (OD)</div>' + row('od') + '<div class="muted" style="margin:10px 0 6px">Left eye (OS)</div>' + row('os');
      }
      // PD is required: it sets where each lens's optical centre sits relative to the pupil.
      // Get it wrong and the wearer looks through the lens off-axis, which induces prism (eye
      // strain and headaches, worse the stronger the prescription). It used to sit behind an
      // unticked "I know my PD" box, so orders arrived without it (real order #172066).
      var pd = '<div class="note"><div style="font-weight:600;margin-bottom:8px">Your Pupil Distance (PD) <span style="color:#b8860b">*</span></div>';
      pd += '<div class="toggle" style="margin:8px 0">'
        + '<button class="opt ' + (s.pdMode === 'single' ? 'sel' : '') + '" data-pdmode="single"><span class="t">Single PD</span></button>'
        + '<button class="opt ' + (s.pdMode === 'dual' ? 'sel' : '') + '" data-pdmode="dual"><span class="t">Dual PD</span></button></div>';
      if (s.pdMode === 'single') pd += '<div class="field"><input data-pd="single" inputmode="decimal" placeholder="PD (mm), usually 54 to 74" value="' + esc(s.pd.single || '') + '"></div>';
      else pd += '<div class="rx-grid" style="grid-template-columns:1fr 1fr"><div class="field"><label>Right / OD</label><input data-pd="right" inputmode="decimal" placeholder="mm" value="' + esc(s.pd.right || '') + '"></div><div class="field"><label>Left / OS</label><input data-pd="left" inputmode="decimal" placeholder="mm" value="' + esc(s.pd.left || '') + '"></div></div>';
      pd += '<div class="muted" style="margin-top:8px">It\'s on your prescription, or <a href="' + esc(acc) + '" target="_blank" rel="noopener">measure it in a minute →</a></div></div>';
      return '<h2>Your prescription</h2>' + modeT + body + pd + '<div class="rx-hint-wrap rx-hint" style="display:none"></div>';
    }
    _step_material() {
      var prices = {};
      this._materials(this.state.program).forEach(function (m) { prices[m.name] = m.price; });
      return '<h2>Lens material</h2>' + this._optList('lensType', prices, {
        'Basic Plastic': 'Standard CR-39 lenses.',
        'Polycarbonate': 'Thinner, lighter, impact-resistant.',
        'High Index 1.67': 'Thinnest option, best for strong prescriptions.'
      });
    }
    _step_review() {
      var s = this.state, f = this._finish(s.feature), c = this._color();
      var self = this, lines = this.lineItems().map(function (l) { return '<div class="line"><span>' + esc(self._lineLabel(l)) + '</span><span class="v">' + (l.price ? money(l.price) : 'Included') + '</span></div>'; }).join('');
      var incl = '<div class="line"><span>Scratch resistance + UV protection</span><span class="v">Included</span></div>';
      var kind = s.program === 'rx' ? 'Prescription lenses' : 'Custom lenses';
      // Lead with the pair itself; the itemized prices sit under "Price details".
      var frameRow;
      if (s.flow === 'new' && s.frame) {
        frameRow = '<div class="pair__row">' + (s.frame.image ? '<img class="pair__img' + (this._angleCls(s.frame.image) ? ' img--angle' : '') + '" src="' + esc(s.frame.image) + '" alt="">' : '')
          + '<div><div class="pair__k">Your frame</div><div class="pair__v">' + esc(s.frame.title) + '</div></div></div>';
      } else {
        var model = s.ownFrame === 'Other' ? (s.ownFrameOther || 'Other').trim() : s.ownFrame;
        frameRow = '<div class="pair__row"><div class="pair__v">Your frame: ' + esc(model) + '</div></div>';
      }
      // The pair photo (frame + lens) leads when there is one; otherwise the lens swatch sits in its row.
      var render = f && c ? this._renderUrl(f, c) : '';
      var pairPhoto = render ? this._renderFigure(render, c.name + ' ' + this._fname(f.name) + ' lenses in ' + this._frameTitle(), this._renderCaption(f), 'pair__render') : '';
      var lensRow = f && c ? '<div class="pair__row">' + (render ? '' : '<img class="pair__sw' + (this._clearish(f) ? ' sw--clear' : '') + '" src="' + esc(this._swatch(f.name, c.name, c)) + '" alt="">')
        + '<div><div class="pair__k">Your lenses</div><div class="pair__v">' + esc(this._lensLine()) + '</div>'
        + (s.program === 'rx' ? '<div class="pair__s">Prescription: ' + esc(s.rxType || '') + '</div>' : '') + '</div></div>' : '';
      var agp = (this.cfg.pricing || {}).antiGlare;
      var ag = '<label class="agbox' + (s.antiGlare ? ' sel' : '') + '"><input type="checkbox" data-ag="1"' + (s.antiGlare ? ' checked' : '') + '>'
        + '<span><span class="t">Add Premium Anti-Glare Coating</span><span class="d">Cuts reflections and glare for clearer vision and better-looking lenses.</span></span>'
        + '<span class="price">+' + money(agp) + '</span></label>';
      // Open by default on phones, where the build sidebar is hidden.
      var open = s.priceOpen !== undefined ? s.priceOpen : !!(window.matchMedia && window.matchMedia('(max-width:880px)').matches);
      var details = '<details class="pdetails" data-pdetails' + (open ? ' open' : '') + '><summary>Price details</summary><div class="lines">' + lines + incl + '</div><div class="total"><span>Total</span><span>' + money(this.total()) + '</span></div></details>';
      return '<h2>Review &amp; comments</h2><div class="pair">' + pairPhoto + frameRow + lensRow + '</div>'
        + ag + details
        + '<div class="field"><label>Comments for our lab (optional)</label><textarea data-comments rows="3" placeholder="Anything we should know?">' + esc(s.comments) + '</textarea></div>'
        + '<p class="disc"><strong>' + kind + ' are made to order and non-returnable. ' + (s.flow === 'existing' ? esc(this._sendinNote()) :'We\'ll build your pair and ship it ready to wear.') + '</strong></p>'
        + '<div class="ship muted">Shipping is free in the US and $29.99 international.</div>'
        + '<div class="err" id="rx-err" style="display:none"></div>';
    }

    /* option-list helpers */
    _optList(group, priceMap, descs) {
      return '<div class="opts">' + Object.keys(priceMap).map(function (k) { return this._optRow(group, k, priceMap[k], descs[k]); }.bind(this)).join('') + '</div>';
    }
    // `label` is the name shown when it differs from the value (finish display names).
    _optRow(group, key, price, desc, thumb, colors, label) {
      var sel = this.state[group] === key;
      return '<button type="button" class="opt ' + (sel ? 'sel' : '') + '" data-group="' + group + '" data-val="' + esc(key) + '" aria-pressed="' + sel + '">' + (thumb || '')
        + '<span class="opt__body"><span class="t">' + esc(label || key) + (colors ? ' <span class="cnt">· ' + colors.count + '</span>' : '') + '</span>'
        + (desc ? '<span class="d">' + esc(desc) + '</span>' : '') + (colors ? colors.dots : '') + '</span>'
        + '<span class="price ' + (price ? '' : 'free') + '">' + (price ? '+' + money(price) : 'Free') + '</span></button>';
    }

    // Action row, pinned to the bottom of the viewport so Continue is always in reach. On phones
    // it also carries the running total (tap for the price breakdown sheet).
    _nav() {
      var last = this._stepIndex() === this._steps().length - 1;
      var t = this._totalText();
      return '<div class="nav" role="group" aria-label="Step navigation">'
        + '<button type="button" class="nav__total" data-msheet aria-haspopup="dialog" aria-label="' + esc(this._totalAria(t)) + '">' + this._navTotalInner(t) + '</button>'
        + '<div class="nav__btns"><button type="button" class="btn btn--o" data-back ' + (this._stepIndex() === 0 ? 'disabled' : '') + '>Back</button>'
        + (!last
          ? '<button type="button" class="btn btn--p" data-next>Continue</button>'
          : '<span class="nav__add"><span class="nav__eta" id="rx-eta">' + esc(this._delivery()) + '</span><button type="button" class="btn btn--g" data-add aria-describedby="rx-eta">Add to cart · ' + money(this.total()) + '</button></span>') + '</div></div>';
    }
    // Prepaid send-in labels are US-only (USPS domestic, incl. territories). Outside the US the
    // platform emails the lab address and the customer ships at their own cost (order #172518).
    _sendinNote() {
      var c = String((this.cfg.settings || {}).country || 'US').toUpperCase();
      if (['US', 'PR', 'VI', 'GU', 'AS', 'MP'].indexOf(c) === -1) {
        return 'Prepaid shipping labels are only available in the US. After checkout we\'ll email you our lab\'s address, and you ship your frame to us at your own cost.';
      }
      return 'After checkout we\'ll email you a prepaid shipping label to send in your frame (US addresses only; outside the US you ship it to our lab at your own cost).';
    }
    // Delivery counts from the order for both flows (settings.deliveryText / deliveryShortText).
    _delivery(short) {
      var st = this.cfg.settings || {};
      return short ? (st.deliveryShortText || 'Delivery: about 3 weeks in the US, 4 to 5 weeks internationally.')
        : (st.deliveryText || 'Delivery in about 3 weeks in the US, or 4 to 5 weeks internationally.');
    }
    // Lens lines priced so far. The new-pair frame line sits beside the "from" prices, not in them.
    _lensLines() { return this.lineItems().filter(function (l) { return l.key !== 'frame'; }); }
    // The phone bar's price: the Total once lenses are priced, else the "from" prices (one or two rows).
    _totalText() {
      if (this._lensLines().length) return { label: 'Total', value: money(this.total()) };
      var rows = this._fromPrices();
      if (rows.length === 1) return rows[0];
      return { label: 'Starting at', value: '', rows: rows };
    }
    _totalAria(t) {
      return (t.rows ? t.rows.map(function (r) { return r.label + ' ' + r.value; }).join(', ') : t.label + ' ' + t.value) + '. View price details';
    }
    _navTotalInner(t) {
      var chev = ' <svg width="11" height="11" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 15l6-6 6 6" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      if (t.rows) return t.rows.map(function (r, i) { return '<span class="nav__from">' + esc(r.label) + ' <strong>' + esc(r.value) + '</strong>' + (i ? '' : chev) + '</span>'; }).join('');
      return '<span class="nav__tl">' + esc(t.label) + chev + '</span><span class="nav__tv">' + esc(t.value) + '</span>';
    }
    _summary() {
      return '<aside class="summary"><h3>Your build</h3><div id="sum-body"></div></aside>';
    }
    _msheet() {
      return '<div class="msheet" id="msheet"><div class="msheet__bd" data-msheet-close></div><div class="msheet__panel" role="dialog" aria-label="Price breakdown"><div class="msheet__grip" data-msheet-close></div><h3>Your build</h3><div id="msheet-body"></div></div></div>';
    }
    _summaryHTML() {
      var s = this.state;
      var fr = '';
      if (s.flow === 'new' && s.frame) fr = '<div class="sumframe">' + (s.frame.image ? '<img src="' + esc(s.frame.image) + '"' + this._angleCls(s.frame.image) + ' alt="">' : '') + '<div><strong>' + esc(s.frame.title) + '</strong><div class="muted">Your new frame</div></div></div>';
      else if (s.flow === 'existing') fr = '<div class="sumframe"><div><strong>' + (s.program === 'rx' ? 'Prescription lenses' : s.program === 'nonrx' ? 'Custom lenses' : 'New lenses') + '</strong><div class="muted">For your William Painter frame</div></div></div>';
      var self = this, lines = this.lineItems().map(function (l) { return '<div class="line"><span>' + esc(self._lineLabel(l)) + '</span><span class="v">' + (l.price ? money(l.price) : 'Included') + '</span></div>'; }).join('');
      var incl = s.flow ? '<div class="line"><span>Scratch resistance + UV protection</span><span class="v">Included</span></div>' : '';
      // No lenses priced yet: show where the lenses start, per program (cheapest lens type +
      // cheapest finish). A new-pair frame keeps its own line above.
      if (!this._lensLines().length) return fr + (lines ? '<div class="lines" style="margin-bottom:14px">' + lines + '</div>' : '')
        + this._fromPrices().map(function (r) { return '<div class="from">' + esc(r.label) + '<strong>' + esc(r.value) + '</strong></div>'; }).join('') + (incl ? '<div class="lines" style="margin-top:12px">' + incl + '</div>' : '');
      return fr + '<div class="lines">' + lines + incl + '</div><div class="total"><span>Total</span><span>' + money(this.total()) + '</span></div>';
    }
    _chartDialog() {
      return '<dialog class="chartdlg" id="rx-chart" aria-labelledby="rx-chart-t"><div class="chartdlg__top"><h3 id="rx-chart-t"></h3>'
        + '<button type="button" class="chartdlg__x" data-chartclose aria-label="Close">×</button></div>'
        + '<div class="chartdlg__scroll"><img alt=""></div><div class="chartdlg__err" hidden>This chart isn\'t available right now.</div></dialog>';
    }
    // "See every color" opens the frame's comparison chart in a dialog (a plain link without one).
    _openChart(a) {
      var d = this.root.querySelector('#rx-chart');
      if (!d || typeof d.showModal !== 'function') return false;
      var img = d.querySelector('img'), err = d.querySelector('.chartdlg__err'), rs = this._renderSet();
      var on = rs && rs.shownOn ? rs.shownOn : this._frameTitle();
      d.querySelector('#rx-chart-t').textContent = a.dataset.chart + ' colors on ' + on;
      err.hidden = true; img.hidden = false;
      img.onerror = function () { img.hidden = true; err.hidden = false; };
      img.alt = 'Every ' + a.dataset.chart + ' color on ' + on + ', light to dark';
      img.src = a.getAttribute('href');
      if (!this._chartBound) {
        this._chartBound = true;
        d.querySelector('[data-chartclose]').onclick = function () { d.close(); };
        d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
      }
      d.showModal();
      return true;
    }
    _refreshSummary() {
      var html = this._summaryHTML(), t = this.total(), tt = this._totalText();
      var body = this.root.querySelector('#sum-body'); if (body) body.innerHTML = html;
      var msb = this.root.querySelector('#msheet-body'); if (msb) msb.innerHTML = html;
      var mb = this.root.querySelector('.nav__total');
      if (mb) { mb.innerHTML = this._navTotalInner(tt); mb.setAttribute('aria-label', this._totalAria(tt)); }
      if (this._prevTotal !== undefined && this._prevTotal !== t) {
        this.root.querySelectorAll('.total').forEach(function (el) { el.classList.remove('total--pulse'); void el.offsetWidth; el.classList.add('total--pulse'); });
      }
      this._prevTotal = t;
    }
    _bindMobile() {
      var r = this.root, sheet = r.querySelector('#msheet');
      if (!sheet) return;
      // Lock the page behind the sheet so the backdrop/panel can't scroll the body (iOS).
      var open = function () { sheet.classList.add('open'); document.body.style.overflow = 'hidden'; };
      var close = function () { sheet.classList.remove('open'); document.body.style.overflow = ''; };
      // The trigger lives in the action row, which re-renders with every step (see _attachNav).
      this._openSheet = open;
      r.querySelectorAll('[data-msheet-close]').forEach(function (b) { b.addEventListener('click', close); });
      if (!this._escBound) { this._escBound = true; document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); }); }
    }
    _scrollTop() {
      try {
        // Target the step heading itself so it lands just below the site's fixed/reveal-on-scroll
        // header. Offset off the header's pinned BOTTOM edge (accounts for the announcement bar
        // above it) plus a gap, measured live.
        var node = (this.shadowRoot && this.shadowRoot.querySelector('h1')) || this;
        var rect = node.getBoundingClientRect();
        var header = document.querySelector('header');
        var pinnedBottom = 0;
        if (header) { var hp = getComputedStyle(header).position; if (hp === 'fixed' || hp === 'sticky') { pinnedBottom = header.getBoundingClientRect().bottom; } }
        var offset = (pinnedBottom > 0 ? pinnedBottom : 110) + 20;
        // Only move the view when the heading is actually hidden under the header or pushed well down
        // the screen. If it's already comfortably visible, leave the scroll position alone.
        if (rect.top < offset || rect.top > window.innerHeight * 0.6) {
          var target = rect.top + window.pageYOffset - offset;
          window.scrollTo(0, target > 0 ? target : 0); // instant: behavior:'smooth' is a no-op on this theme
        }
      } catch (e) {}
    }

    /* ---------- events ---------- */
    _bindStep() {
      var self = this, r = this.root, s = this.state;
      r.querySelectorAll('[data-flow]').forEach(function (b) { b.onclick = function () { self._setFlow(b.dataset.flow); self._renderStep(); }; });
      r.querySelectorAll('[data-card]').forEach(function (b) { b.onclick = function () {
        self.state.frame = (self.cfg.frames || []).find(function (f) { return String(f.id) === b.dataset.card; });
        self._renderStep();
      }; });
      // A colour dot shows that frame twin on its model card and selects it.
      r.querySelectorAll('[data-fdot]').forEach(function (b) { b.onclick = function () {
        var f = (self.cfg.frames || []).find(function (x) { return String(x.id) === b.dataset.fdot; });
        if (!f) return;
        (self._modelShown || (self._modelShown = {}))[b.dataset.model] = f.id;
        self.state.frame = f;
        self._renderStep();
      }; });
      r.querySelectorAll('[data-program]').forEach(function (b) { b.onclick = function () {
        if (b.disabled) return;
        self._setProgram(b.dataset.program);
        self._renderStep();
      }; });
      r.querySelectorAll('[data-group]').forEach(function (b) { b.onclick = function () {
        var g = b.dataset.group, val = b.dataset.val;
        // A different finish starts at Dark again; a colour change within the finish keeps the choice.
        if (g === 'feature' && self.state.feature !== val) self.state.intensity = DEFAULT_INTENSITY;
        self.state[g] = val;
        if (g === 'lensType') self.state.lensAuto = false;
        if (g === 'feature') {
          var f = self._finish(val), colors = f ? f.colors : [];
          if (!colors.some(function (c) { return c.name === self.state.tintColor; })) self.state.tintColor = colors.length ? colors[0].name : null;
          // Single-color finishes (Clear, Blue Light Blocker) need no drill-in unless they take an intensity.
          self.state.featureDrilled = !!(f && (colors.length > 1 || f.hasIntensity));
        }
        self._renderStep();
        // Opening a finish swaps the whole view: bring its heading back into sight.
        if (g === 'feature' && self.state.featureDrilled) self._scrollTop();
      }; });
      r.querySelectorAll('[data-tint]').forEach(function (b) { b.onclick = function () { self.state.tintColor = b.dataset.tint; self._renderStep(); }; });
      // Photos: fade in on load, swatch on failure. Warm only what is likely next: the other two
      // darkness levels of the chosen colour, and a colour once the pointer or focus is on it.
      this._bindRenders();
      var tf = s.stepId === 'lenses' && s.featureDrilled ? this._finish(s.feature) : null;
      if (tf) {
        var cur = this._color() || tf.colors[0];
        if (tf.hasIntensity) INTENSITIES.forEach(function (i) { self._preload(self._renderUrl(tf, cur, i)); });
        r.querySelectorAll('[data-tint]').forEach(function (b) {
          var warm = function () { self._preload(self._renderUrl(tf, tf.colors.find(function (c) { return c.name === b.dataset.tint; }))); };
          b.addEventListener('pointerenter', warm); b.addEventListener('focus', warm);
        });
      }
      r.querySelectorAll('[data-chart]').forEach(function (a) { a.onclick = function (e) { if (self._openChart(a)) e.preventDefault(); }; });
      r.querySelectorAll('[data-intensity]').forEach(function (b) { b.onclick = function () { self.state.intensity = b.dataset.intensity; self._renderStep(); }; });
      var fbk = r.querySelector('[data-featureback]'); if (fbk) fbk.onclick = function () { self.state.featureDrilled = false; self._renderStep(); self._scrollTop(); };
      r.querySelectorAll('[data-ag]').forEach(function (b) { b.onchange = function () { self.state.antiGlare = !!b.checked; self._renderStep(); }; });
      var gd = r.querySelector('[data-guide]'); if (gd) gd.onclick = function () { self.state.guideOpen = !self.state.guideOpen; self._renderStep(); };
      var pdt = r.querySelector('[data-pdetails]'); if (pdt) pdt.addEventListener('toggle', function () { self.state.priceOpen = pdt.open; });
      // Phones show the colours as one swipeable row: keep the chosen colour in view.
      var tr = r.querySelector('.tints'), ts = tr && tr.querySelector('.tint.sel');
      if (tr && ts && tr.scrollWidth > tr.clientWidth) tr.scrollLeft = Math.max(0, ts.offsetLeft - (tr.clientWidth - ts.offsetWidth) / 2);
      r.querySelectorAll('[data-rxmode]').forEach(function (b) { b.onclick = function () { self.state.rxMode = b.dataset.rxmode; self._renderStep(); }; });
      r.querySelectorAll('[data-pdmode]').forEach(function (b) { b.onclick = function () { self.state.pdMode = b.dataset.pdmode; self._renderStep(); }; });
      r.querySelectorAll('[data-rx]').forEach(function (i) { i.oninput = function () { self.state.rxValues[i.dataset.rx] = i.value; self.state.rxTouched = true; self._updateNav(); self._refreshRxHint(); }; });
      r.querySelectorAll('[data-pd]').forEach(function (i) { i.oninput = function () { self.state.pd[i.dataset.pd] = i.value; self.state.rxTouched = true; self._updateNav(); self._refreshRxHint(); }; });
      var ph = r.querySelector('#rxphoto');
      if (ph) ph.onchange = function () {
        var f = ph.files[0] || null;
        self.state.photoError = '';
        if (f) {
          var okType = /^image\//.test(f.type) || f.type === 'application/pdf' || /\.(jpe?g|png|heic|heif|webp|gif|pdf)$/i.test(f.name);
          var maxMB = 15;
          if (!okType) { self.state.photoError = 'Please upload an image (JPG, PNG, HEIC) or a PDF.'; self.state.photo = null; }
          else if (f.size > maxMB * 1024 * 1024) { self.state.photoError = 'That file is ' + (f.size / 1048576).toFixed(1) + ' MB. Please upload one under ' + maxMB + ' MB.'; self.state.photo = null; }
          else { self.state.photo = f; }
        } else { self.state.photo = null; }
        self._renderStep();
      };
      r.querySelectorAll('[data-own]').forEach(function (b) { b.onclick = function () {
        self.state.ownFrame = b.dataset.own;
        self._renderStep();
        // Other opens the text field: put the cursor in it.
        var o = b.dataset.own === 'Other' && self.root.querySelector('[data-ownframeother]');
        if (o) o.focus();
      }; });
      // A colour dot shows that frame twin on its style card and selects it.
      r.querySelectorAll('[data-owndot]').forEach(function (b) { b.onclick = function () {
        (self._ownShown || (self._ownShown = {}))[b.dataset.ownmodel] = b.dataset.owndot;
        self.state.ownFrame = b.dataset.owndot;
        self._renderStep();
      }; });
      var ofo = r.querySelector('[data-ownframeother]');
      if (ofo) ofo.oninput = function () { self.state.ownFrameOther = ofo.value; self._updateNav(); };
      var cm = r.querySelector('[data-comments]'); if (cm) cm.oninput = function () { self.state.comments = cm.value; };
      this._refreshRxHint();
    }
    _bindNav() {}
    _updateNav() {
      var n = this.root.querySelector('[data-next]'); if (n) n.disabled = !this.canAdvance();
      this._syncTopbar();
    }

    /* ---------- phones: "next step" bar under the site header ---------- */
    // On phones the action row is pinned to the bottom of the screen, where browser chrome and
    // Shopify's preview bar can cover it. Once the step has a valid choice, a compact bar slides
    // down under the site header with the choice and the same Continue / Add to cart. It only
    // forwards clicks to the bottom row's buttons, so there is one path for each action.
    _topbar() {
      return '<div class="topbar" id="rx-topbar" role="group" aria-label="Next step"><span class="topbar__txt"><span class="topbar__k"></span><span class="topbar__v"></span></span>'
        + '<button type="button" class="btn btn--p" data-topbar tabindex="-1"></button></div><div class="sr" aria-live="polite" id="rx-topbar-live"></div>';
    }
    _topbarText() {
      var s = this.state;
      switch (s.stepId) {
        case 'start': return s.flow === 'new' ? (s.frame ? s.frame.title : '') : (s.ownFrame === 'Other' ? 'Other: ' + (s.ownFrameOther || '').trim() : s.ownFrame);
        case 'lensType': return s.program === 'rx' ? 'Prescription lenses' : 'Nonprescription lenses';
        case 'rxType': return s.rxType || '';
        case 'lenses': return this._lensLine();
        case 'prescription': return s.rxMode === 'photo' ? 'Prescription photo attached' : 'Prescription entered';
        case 'material': return s.lensType || '';
        case 'review': return this._lensLine();
      }
      return '';
    }
    // The bar sits just below whatever is pinned to the top of the screen (the announcement bar
    // and the site header), measured live because both can change height or scroll away.
    _headerBottom() {
      var bottom = 0;
      document.querySelectorAll('header, .ann-bar, #shopify-section-announcement-bar, #shopify-section-header').forEach(function (el) {
        var cs = getComputedStyle(el);
        if (!/fixed|sticky/.test(cs.position) || cs.display === 'none' || cs.visibility === 'hidden') return;
        var r = el.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight / 3) bottom = Math.max(bottom, r.bottom);
      });
      return Math.round(bottom);
    }
    _placeTopbar() {
      this.style.setProperty('--rx-top', this._headerBottom() + 'px');
    }
    _syncTopbar() {
      var bar = this.root && this.root.querySelector('#rx-topbar');
      if (!bar) return;
      var self = this, s = this.state, last = this._stepIndex() === this._steps().length - 1;
      if (!this._barBound) {
        this._barBound = true;
        // Re-measure on the next frame, and again once scrolling settles: the header animates
        // when it hides or shows, so a single measurement can land mid-transition.
        var queued = false, settle = null;
        var place = function () {
          if (!queued) { queued = true; requestAnimationFrame(function () { queued = false; self._placeTopbar(); }); }
          clearTimeout(settle); settle = setTimeout(function () { self._placeTopbar(); }, 350);
        };
        window.addEventListener('scroll', place, { passive: true });
        window.addEventListener('resize', place);
        document.addEventListener('transitionend', function (e) {
          var t = e.target;
          if (t && t.matches && t.matches('header, .ann-bar, #shopify-section-announcement-bar, #shopify-section-header')) self._placeTopbar();
        }, true);
      }
      this._placeTopbar();
      var btn = bar.querySelector('[data-topbar]');
      var bottomBtn = this.root.querySelector(last ? '[data-add]' : '[data-next]');
      var text = this._topbarText();
      var ready = !!(bottomBtn && !bottomBtn.disabled && this.canAdvance() && text);
      bar.querySelector('.topbar__k').textContent = last ? 'Your lenses' : 'Selected';
      bar.querySelector('.topbar__v').textContent = text;
      btn.textContent = bottomBtn ? bottomBtn.textContent : '';
      btn.onclick = function () { var b = self.root.querySelector(last ? '[data-add]' : '[data-next]'); if (b && !b.disabled) b.click(); };
      // Mirror the bottom Add to cart while it works ("Adding…", then re-enabled on failure).
      if (this._barMirror) { this._barMirror.disconnect(); this._barMirror = null; }
      if (last && bottomBtn && window.MutationObserver) {
        this._barMirror = new MutationObserver(function () { btn.textContent = bottomBtn.textContent; btn.disabled = bottomBtn.disabled; });
        this._barMirror.observe(bottomBtn, { attributes: true, childList: true, characterData: true, subtree: true });
      }
      btn.disabled = !!(bottomBtn && bottomBtn.disabled);
      // A new step starts hidden; the bar comes back once that step has a valid choice.
      var stepChanged = this._barStep !== s.stepId;
      this._barStep = s.stepId;
      clearTimeout(this._barTimer);
      var show = function () {
        bar.classList.add('on');
        btn.tabIndex = 0;
        if (!self._barShown) {
          self._barShown = true;
          var live = self.root.querySelector('#rx-topbar-live');
          if (live) live.textContent = text + '. ' + btn.textContent + ' is available at the top of the screen.';
        }
      };
      if (!ready || stepChanged) { bar.classList.remove('on'); btn.tabIndex = -1; this._barShown = false; }
      if (ready) { if (stepChanged) this._barTimer = setTimeout(show, 320); else show(); }
    }
    _attachNav() {
      var self = this, r = this.root;
      var back = r.querySelector('[data-back]'); if (back) back.onclick = function () {
        // From the finish drill-in, Back returns to the finish list (not the previous step).
        if (self.state.stepId === 'lenses' && self.state.featureDrilled) { self.state.featureDrilled = false; self._dir = 'back'; self._renderStep(); self._scrollTop(); return; }
        if (self._stepIndex() > 0) { self._dir = 'back'; self._go(-1); self._renderStep(); self._scrollTop(); }
      };
      var next = r.querySelector('[data-next]'); if (next) { next.disabled = !self.canAdvance(); next.onclick = function () { if (self.canAdvance()) { self._dir = 'fwd'; self.state.featureDrilled = false; self._go(1); self._renderStep(); self._scrollTop(); } }; }
      var add = r.querySelector('[data-add]'); if (add) add.onclick = function () { self._addToCart(add); };
      var tot = r.querySelector('.nav__total'); if (tot) tot.onclick = function () { if (self._openSheet) self._openSheet(); };
    }

    /* ---------- cart ---------- */
    properties() {
      var s = this.state, p = {}, f = this._finish(s.feature), c = this._color();
      p['_rx_bundle'] = s.bundle;
      p['_flow'] = s.flow;
      p['_lens_program'] = s.program;
      if (s.flow === 'new' && s.frame) { p['Frame'] = s.frame.title; p['_frame_handle'] = s.frame.handle; p['_frame_variant_id'] = String(s.frame.id); }
      // Hidden (underscore) property so the cart-group script can show the frame's photo as the
      // bundle's lead thumbnail. Hidden from the customer-facing cart/checkout, kept on the order.
      if (s.flow === 'new' && s.frame && s.frame.image) { p['_rx_frame_image'] = s.frame.image; }
      p['Lens Type'] = s.rxType;
      p['Lens Feature'] = s.feature || '';
      if (f && c && f.colors.length > 1) p['Tint Color'] = c.name;
      if (f && f.hasIntensity) p['Tint Intensity'] = s.intensity;
      p['Lens Material'] = s.lensType;
      p['Anti-Glare'] = s.antiGlare ? 'Yes' : 'No';
      if (s.flow === 'existing' && s.ownFrame) {
        p['Frame Model'] = s.ownFrame === 'Other' ? (s.ownFrameOther || 'Other').trim() : s.ownFrame;
      }
      // Prescription details only exist on prescription orders. Nonprescription orders must not
      // carry them: the lab would read "Photo uploaded" as a prescription on file.
      if (s.program === 'rx') {
        p['PD'] = s.pdMode === 'single' ? (s.pd.single || '') : ('R ' + (s.pd.right || '') + ' / L ' + (s.pd.left || ''));
        if (s.rxMode === 'manual') {
          p['Prescription'] = ['od_sph', 'od_cyl', 'od_axis', 'od_add', 'os_sph', 'os_cyl', 'os_axis', 'os_add'].map(function (k) { return k.toUpperCase() + ':' + (s.rxValues[k] || '-'); }).join(' ');
        } else { p['Prescription'] = 'Photo uploaded'; }
      }
      if (s.comments) p['Comments'] = s.comments;
      return p;
    }
    _vid(key) { var o = this.cfg.variantOverrides || {}; return o[key] || (this.cfg.variantIds || {})[key]; }

    _addToCart(btn) {
      var self = this, items = this.lineItems(), err = this.root.querySelector('#rx-err');
      var requireOk = function (response) {
        if (!response || !response.ok) throw new Error('Cart request failed');
        return response;
      };
      var readCart = function () {
        return fetch('/cart.js?rx_gift=' + Date.now(), {
          credentials: 'same-origin',
          cache: 'no-store',
          headers: { 'Accept': 'application/json' }
        }).then(requireOk).then(function (response) { return response.json(); });
      };
      var sleep = function (ms) { return new Promise(function (resolve) { setTimeout(resolve, ms); }); };
      // The theme's own cart listeners run the same gift policy after every /cart/add. While one
      // of those is in flight, reconcile() hands back the cart it was given untouched, so wait
      // for it to finish (up to 5s) and start from a fresh cart.
      var giftIdle = function () {
        var deadline = Date.now() + 5000;
        var poll = function () {
          if (!window.__gift_enforcing || Date.now() >= deadline) return Promise.resolve();
          return sleep(100).then(poll);
        };
        return poll();
      };
      var reconcileGift = function () {
        // Only new-pair orders enter the warehouse-to-lab ride-along flow.
        if (self.state.flow !== 'new') return Promise.resolve(null);
        var config = window.FREE_GIFT_CONFIG || {};
        if (!config.enabled && !(config.perFrame || {}).enabled) return Promise.resolve(null);
        var gift = window.WPFreeGift;
        if (!gift || typeof gift.reconcile !== 'function' || typeof gift.qualifies !== 'function' || typeof gift.findLine !== 'function') {
          return Promise.reject(new Error('Gift service is unavailable'));
        }
        var problem = function (cart) {
          var giftLine = gift.findLine(cart);
          var shouldHaveGift = gift.qualifies(cart);
          var expected = typeof gift.expectedQuantity === 'function' ? gift.expectedQuantity(cart) : 1;
          if (shouldHaveGift && (!giftLine || giftLine.item.quantity !== expected)) return 'Gift was not added';
          if (!shouldHaveGift && giftLine) return 'Gift eligibility was not reconciled';
          if (typeof gift.sloanQuantity === 'function' && typeof gift.expectedSloanQuantity === 'function' &&
              gift.sloanQuantity(cart) !== gift.expectedSloanQuantity(cart)) return 'Sloan gift eligibility was not reconciled';
          if (typeof gift.discountReady === 'function' && !gift.discountReady(cart)) return 'Early access discount could not be verified';
          return null;
        };
        var pass = function () {
          return giftIdle().then(readCart).then(function (cart) { return gift.reconcile(cart); });
        };
        return pass().then(function (cart) {
          if (!problem(cart)) return cart;
          // A listener may have started its own gift write right after ours; let it land, then
          // check once more before telling the customer anything went wrong.
          return sleep(600).then(pass).then(function (again) {
            var p = problem(again);
            if (p) throw new Error(p);
            return again;
          });
        });
      };
      var navigateToCheckout = function (cart) {
        // Rekey only after the complete cart transaction. A second pair after browser Back
        // must receive a fresh bundle token.

        self.state.bundle = uid();
        self._rxCartCommitted = false;
        self._handedOff = true;
        try { if (window.Rebuy && window.Rebuy.SmartCart && window.Rebuy.SmartCart.hide) window.Rebuy.SmartCart.hide(); } catch (e) {}
        var giftSettings = window.FREE_GIFT_CONFIG || {};
        var earlyGiftSettings = giftSettings.perFrame || {};
        var member = earlyGiftSettings.enabled && (!earlyGiftSettings.requireEntryCode ||
          (cart && window.WPBFEarlyAccess && window.WPBFEarlyAccess.isMember(cart)));
        var code = !member && self.state.flow === 'new' && self.cfg.settings.frameDiscountCode;
        window.location.href = code ? ('/checkout?discount=' + encodeURIComponent(code)) : '/checkout';
      };
      var showFailure = function (e) {
        var pairLost = !!(e && e.rxPairLost);
        if (pairLost) {
          // The partial pair was taken back out. Start the next attempt on a fresh bundle token.
          self._rxCartCommitted = false;
          self.state.bundle = uid();
        }
        err.style.display = 'block';
        err.textContent = pairLost
          ? 'We couldn\'t add your lenses to the cart. Please try again.'
          : self._rxCartCommitted
            ? 'Your lenses were added, but we couldn\'t prepare your gifts and savings. Please retry checkout.'
            : 'Something went wrong adding to cart. Please try again.';

        btn.disabled = false;
        btn.textContent = self._rxCartCommitted ? 'Retry gift & checkout' : 'Add to cart · ' + money(self.total());
      };

      // One pair is exactly these lines. The anchor (the frame, or the first lens line of a
      // send-in pair) carries the full spec; every other line carries only the bundle token
      // and its label.
      var props = this.properties(), token = props._rx_bundle;
      var lines = items.map(function (l, i) {
        return {
          id: self._aid(l),
          quantity: 1,
          properties: i === 0 ? Object.assign({ _rx_label: l.label }, props) : { _rx_bundle: token, _rx_label: l.label }
        };
      });
      // Add lines in ONE request, so no other cart write can land between the frame and its
      // lenses (Shopify keeps only one of two overlapping cart writes). The photo goes up as a
      // multipart file property on the anchor, in the same request.
      var withPhoto = !!(self.state.photo && self.state.program === 'rx' && self.state.rxMode === 'photo');
      var addLines = function (list) {
        if (withPhoto && list.indexOf(lines[0]) > -1) {
          var fd = new FormData();
          list.forEach(function (ln, i) {
            var k = 'items[' + i + ']';
            fd.append(k + '[id]', ln.id); fd.append(k + '[quantity]', 1);
            if (ln === lines[0]) {
              fd.append(k + '[properties][Prescription Photo]', self.state.photo);
              Object.keys(props).forEach(function (p) { fd.append(k + '[properties][' + p + ']', props[p]); });
              fd.append(k + '[properties][_rx_label]', ln.properties._rx_label);
            } else {
              Object.keys(ln.properties).forEach(function (p) { fd.append(k + '[properties][' + p + ']', ln.properties[p]); });
            }
          });
          return fetch('/cart/add.js', { method: 'POST', body: fd }).then(requireOk);
        }
        return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: list }) }).then(requireOk);
      };
      var updateCart = function (updates) {
        return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) }).then(requireOk);
      };
      // Quiet window: while the pair is written and checked, keep the theme's gift policy (it
      // stands down while __gift_enforcing is set) and rx-cart-lock.js (stands down while
      // __rx_adding is set) off the cart. Always released, and after 10s no matter what.
      var quiet = function (work) {
        var safety, released = false;
        var release = function () {
          if (released) return;
          released = true; clearTimeout(safety);
          window.__gift_enforcing = false;
          window.__rx_adding = false;
        };
        return giftIdle().then(function () {
          window.__gift_enforcing = true;
          window.__rx_adding = true;
          safety = setTimeout(release, 10000);
          return work();
        }).then(function (value) { release(); return value; }, function (e) { release(); throw e; });
      };
      // Compare the cart with this pair: every line present (variant + bundle token + label) at qty 1.
      var pairCheck = function (cart) {
        var have = (cart.items || []).filter(function (it) { return it.properties && it.properties._rx_bundle === token; });
        var missing = [], fix = {}, n = 0;
        lines.forEach(function (ln) {
          for (var j = 0; j < have.length; j++) {
            if (String(have[j].variant_id) === String(ln.id) && have[j].properties._rx_label === ln.properties._rx_label) {
              if (have[j].quantity !== 1) { fix[have[j].key] = 1; n++; }
              have.splice(j, 1);
              return;
            }
          }
          missing.push(ln);
        });
        have.forEach(function (it) { fix[it.key] = 0; n++; }); // not part of this pair's spec
        return { ok: !missing.length && !n, missing: missing, fix: fix, n: n };
      };
      var pairLost = function () { var e = new Error('Pair incomplete'); e.rxPairLost = true; return e; };
      // Never let an incomplete pair reach checkout: repair once, and if the pair is still not
      // whole, take all of its lines back out and stop.
      var ensurePair = function () {
        return readCart().then(function (cart) {
          var first = pairCheck(cart);
          if (first.ok) return cart;
          return (first.n ? updateCart(first.fix) : Promise.resolve())
            .then(function () { if (first.missing.length) return addLines(first.missing); })
            .catch(function () {})
            .then(readCart)
            .then(function (again) {
              if (pairCheck(again).ok) return again;
              var out = {};
              (again.items || []).forEach(function (it) { if (it.properties && it.properties._rx_bundle === token) out[it.key] = 0; });
              return (Object.keys(out).length ? updateCart(out) : Promise.resolve())
                .catch(function () {})
                .then(function () { throw pairLost(); });
            });
        });
      };
      var checkAndGo = function () {
        return quiet(ensurePair).then(navigateToCheckout);
      };

      // Gift reconciliation runs after the lens lines are committed. If it fails,
      // retry only the gift step so the bundle is not duplicated.
      if (self._rxCartCommitted) {
        btn.disabled = true; btn.textContent = 'Adding gift…';
        reconcileGift().then(checkAndGo).catch(showFailure);
        return;
      }
      var missing = items.filter(function (l) { return !self._aid(l); });
      if (missing.length) {
        err.style.display = 'block';
        err.textContent = 'Add-to-cart isn\'t wired yet. These options have no variant ID: ' + missing.map(function (l) { return l.label; }).join(', ') + '.';
        return;
      }
      btn.disabled = true; btn.textContent = 'Adding…';
      quiet(function () {
        // A failed add falls through to ensurePair, which repairs it or takes it back out.
        return addLines(lines).catch(function () {}).then(ensurePair);
      }).then(function () {
        self._rxCartCommitted = true;
        return reconcileGift();
      }).then(checkAndGo).catch(showFailure);
    }
  }

  // override _renderStep to also re-attach nav handlers
  var _origRender = RxBuilder.prototype._renderStep;
  RxBuilder.prototype._renderStep = function () { _origRender.call(this); this._attachNav(); this._syncTopbar(); };

  customElements.define('wp-rx-builder', RxBuilder);
})();
